const goolgeSettings = {
    setting: [
        {
            featureType: "administrative",
            elementType: "geometry",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "administrative.land_parcel",
            elementType: "labels",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "poi",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "poi",
            elementType: "labels.text",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "road",
            elementType: "labels.icon",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "road.local",
            elementType: "labels",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "transit",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        }
    ]
};

const infoOptions = {
    maxWidth: "100%",
    maxHeight: "100%",
    closeBoxMargin: "0px",
    closeBoxURL: false,
    // infoBoxClearance: new google.maps.Size(1, 1),
    boxStyle: {
        padding: "0px 0px 0px 0px",
        width: "100%",
        height: "100%"
    },
    pixelOffset: {
        width: 0,
        height: -35
    }
};

const slickNavOptions = {
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    nextArrow:
        '<button type="button" title="Nästa fråga" class="slick-next">Next</button>',
    prevArrow:
        '<button type="button" title="Föregående fråga" class="slick-prev">Previous</button>',
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 4
            }
        },
        {
            breakpoint: 321,
            settings: {
                slidesToShow: 3
            }
        }
    ]
};

const slickOptions = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: ".slider-nav",
    draggable: false,
    swipe: false,
    infinite: false,
    accessibility: false
};

const slickOptionsOpinion = {
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false
};

const mapBoxSettings = {
    accessToken:
        "pk.eyJ1Ijoicmlja2FyZDg5IiwiYSI6ImNsbHo2cmlzdTBudTQzZG4xeWUxbnlsazYifQ.1U9zona99cqOO9RLmFufFA",

    mapStyle: {
        version: 8,
        name: "Mapbox Satellite",
        metadata: {
            "mapbox:type": "default",
            "mapbox:origin": "satellite-streets-v12",
            "mapbox:sdk-support": {
                "js": "3.0.0",
                "android": "11.0.0",
                "ios": "11.0.0"
            },
            "mapbox:autocomposite": true,
            "mapbox:groups": {
                "Transit, transit-labels": {
                    "name": "Transit, transit-labels",
                    "collapsed": true
                },
                "Administrative boundaries, admin": {
                    "name": "Administrative boundaries, admin",
                    "collapsed": true
                },
                "Transit, bridges": {"name": "Transit, bridges", "collapsed": true},
                "Road network, bridges": {
                    "name": "Road network, bridges",
                    "collapsed": true
                },
                "Road network, tunnels": {
                    "name": "Road network, tunnels",
                    "collapsed": true
                },
                "Road network, road-labels": {
                    "name": "Road network, road-labels",
                    "collapsed": true
                },
                "Natural features, natural-labels": {
                    "name": "Natural features, natural-labels",
                    "collapsed": true
                },
                "Road network, surface": {
                    "name": "Road network, surface",
                    "collapsed": true
                },
                "Walking, cycling, etc., barriers-bridges": {
                    "name": "Walking, cycling, etc., barriers-bridges",
                    "collapsed": true
                },
                "Place labels, place-labels": {
                    "name": "Place labels, place-labels",
                    "collapsed": true
                },
                "Point of interest labels, poi-labels": {
                    "name": "Point of interest labels, poi-labels",
                    "collapsed": true
                },
                "Walking, cycling, etc., tunnels": {
                    "name": "Walking, cycling, etc., tunnels",
                    "collapsed": true
                },
                "Walking, cycling, etc., walking-cycling-labels": {
                    "name": "Walking, cycling, etc., walking-cycling-labels",
                    "collapsed": true
                },
                "Walking, cycling, etc., surface": {
                    "name": "Walking, cycling, etc., surface",
                    "collapsed": true
                },
                "Satellite imagery, land": {
                    "name": "Satellite imagery, land",
                    "collapsed": true
                },
                "Transit, ferry-aerialway-labels": {
                    "name": "Transit, ferry-aerialway-labels",
                    "collapsed": true
                }
            },
            "mapbox:decompiler": {
                "id": "cllz8h5sr00nl01nz3me5bi46",
                "componentVersion": "18.0.0",
                "strata": [
                    {
                        "id": "satellite-streets-v12",
                        "order": [
                            ["transit", "built"],
                            ["satellite", "land"],
                            ["walking-cycling", "tunnels"],
                            ["road-network", "tunnels"],
                            ["walking-cycling", "surface"],
                            ["road-network", "surface"],
                            ["transit", "surface"],
                            ["walking-cycling", "barriers-bridges"],
                            ["road-network", "bridges"],
                            ["transit", "bridges"],
                            ["admin-boundaries", "admin"],
                            ["road-network", "road-labels"],
                            ["walking-cycling", "walking-cycling-labels"],
                            ["transit", "ferry-aerialway-labels"],
                            ["natural-features", "natural-labels"],
                            ["point-of-interest-labels", "poi-labels"],
                            ["transit", "transit-labels"],
                            ["place-labels", "place-labels"]
                        ]
                    }
                ],
                "components": {
                    "satellite": "18.0.0",
                    "road-network": "18.0.0",
                    "walking-cycling": "18.0.0",
                    "admin-boundaries": "18.0.0",
                    "natural-features": "18.0.0",
                    "point-of-interest-labels": "18.0.0",
                    "transit": "18.0.0",
                    "place-labels": "18.0.0"
                },
                "propConfig": {
                    "satellite": {},
                    "road-network": {
                        "roadsFont": ["DIN Pro Medium", "Arial Unicode MS Regular"],
                        "colorRoad": "hsla(0, 0%, 80%, 0.8)",
                        "iconSaturation": -0.5,
                        "construction": false,
                        "colorRoadLabel": "hsl(0, 0%, 100%)",
                        "fadeOutRoadsOnZoom": true,
                        "colorBase": "hsl(0, 0%, 0%)",
                        "roadsSize": 1.1,
                        "colorMotorwayTrunk": "hsla(40, 90%, 70%, 0.8)",
                        "polygonFeatures": false,
                        "colorPathOutline": "hsla(40, 95%, 90%, 0.8)",
                        "roadMarkings": false,
                        "turningCircles": false,
                        "colorRoadOutline": "hsla(0, 1%, 10%, 0.7)"
                    },
                    "walking-cycling": {
                        "roadsFont": ["DIN Pro Medium", "Arial Unicode MS Regular"],
                        "colorRoad": "hsla(0, 0%, 80%, 0.8)",
                        "golfHoleLabelLine": false,
                        "colorGreenspace": "hsl(94, 100%, 14%)",
                        "colorPoi": "hsl(0, 0%, 100%)",
                        "colorPoiParkLike": "hsl(110, 100%, 80%)",
                        "fadeOutPathsOnZoom": true,
                        "walkingCyclingPisteBackground": false,
                        "colorRoadLabel": "hsl(0, 0%, 100%)",
                        "colorBase": "hsl(0, 0%, 0%)",
                        "roadsSize": 1.1,
                        "poiEtcFont": ["DIN Pro Bold", "Arial Unicode MS Bold"],
                        "colorPathOutline": "hsla(40, 95%, 90%, 0.8)",
                        "pedestrianPolygonFeatures": false,
                        "colorRoadOutline": "hsla(0, 1%, 10%, 0.7)",
                        "labels": true
                    },
                    "admin-boundaries": {
                        "admin0Width": 1.5,
                        "colorBase": "hsl(0, 0%, 0%)",
                        "colorAdminBoundary": "hsl(260, 15%, 80%)",
                        "admin0DashPattern": "Dash on zoom"
                    },
                    "natural-features": {
                        "poiEtcFont": ["DIN Pro Bold", "Arial Unicode MS Bold"],
                        "colorBase": "hsl(0, 0%, 0%)",
                        "colorWater": "hsl(240, 100%, 62%)",
                        "colorPoi": "hsl(0, 0%, 100%)",
                        "labelHalo": true,
                        "poiIconScale": 0.8
                    },
                    "point-of-interest-labels": {
                        "poiIconBackground": "Circle",
                        "poiEtcFont": ["DIN Pro Bold", "Arial Unicode MS Bold"],
                        "colorBase": "hsl(0, 0%, 0%)",
                        "colorPoi": "hsl(0, 0%, 100%)",
                        "colorPoiParkLike": "hsl(110, 100%, 80%)",
                        "colorPoiMedical": "hsl(360, 100%, 80%)",
                        "colorPoiEducation": "hsl(30, 100%, 80%)",
                        "poiIconScale": 0.8
                    },
                    "transit": {
                        "matchLabelAndIcon": false,
                        "roadsFont": ["DIN Pro Medium", "Arial Unicode MS Regular"],
                        "aeroways": false,
                        "poiIconScale": 0.8,
                        "colorPoi": "hsl(0, 0%, 100%)",
                        "colorAirport": "hsl(0, 0%, 100%)",
                        "colorTransit": "hsl(204, 100%, 80%)",
                        "poiIconBackground": "Rectangle",
                        "colorBase": "hsl(0, 0%, 0%)",
                        "colorWater": "hsl(240, 100%, 62%)",
                        "roadsSize": 1.1,
                        "railways": false,
                        "ferries": false,
                        "poiEtcFont": ["DIN Pro Bold", "Arial Unicode MS Bold"],
                        "colorRoadOutline": "hsla(0, 1%, 10%, 0.7)"
                    },
                    "place-labels": {
                        "continentsSize": 1.1,
                        "statesSize": 1.1,
                        "settlements": true,
                        "settlementsMinorSize": 1.1,
                        "settlementsMajorSize": 1.1,
                        "colorPlaceLabel": "hsl(0, 0%, 100%)",
                        "settlementSubdivisionsSize": 1.1,
                        "colorBase": "hsl(0, 0%, 0%)",
                        "countries": true,
                        "countriesSize": 1.1,
                        "language": "Local",
                        "settlementsMinorFont": [
                            "DIN Pro Medium",
                            "Arial Unicode MS Regular"
                        ],
                        "settlementsDensity": 3,
                        "settlementSubdivisionsFont": [
                            "DIN Pro Medium",
                            "Arial Unicode MS Regular"
                        ],
                        "continents": true
                    }
                }
            },
            "mapbox:uiParadigm": "global"
        },

        sources: {
            "mapbox": {
                "url": "mapbox://mapbox.satellite",
                "type": "raster",
                "tileSize": 256
            },
            "mapbox-dem": {
                "url": "mapbox://mapbox.mapbox-terrain-dem-v1",
                "type": "raster-dem",
                "tileSize": 512
            },
            "composite": {
                "url": "mapbox://mapbox.mapbox-streets-v8",
                "type": "vector"
            }
        },

        center : [13.196228297526488, 55.702122109550686],

        zoom : 17.02298616882512,

        bearing : 0,
        pitch : 0,
        terrain : {"source": "mapbox-dem"},

        fog : {
            "range": [1, 10],
            "color": [
                "interpolate",
                ["exponential", 1.2],
                ["zoom"],
                5.5,
                "hsl(240, 12%, 70%)",
                6,
                "hsl(0, 0%, 100%)"
            ],
            "high-color": [
                "interpolate",
                ["exponential", 1.2],
                ["zoom"],
                5.5,
                "hsl(240, 12%, 7%)",
                6,
                "hsl(38, 63%, 84%)"
            ],
            "space-color": [
                "interpolate",
                ["exponential", 1.2],
                ["zoom"],
                5.5,
                "hsl(240, 12%, 9%)",
                6,
                "hsl(199, 61%, 80%)"
            ],
            "horizon-blend": [
                "interpolate",
                ["exponential", 1.2],
                ["zoom"],
                5.5,
                0.008,
                6,
                0.15
            ],
            "star-intensity": [
                "interpolate",
                ["exponential", 1.2],
                ["zoom"],
                5.5,
                0.1,
                6,
                0
            ]
        },

        sprite : "mapbox://sprites/rickard89/cllz8h5sr00nl01nz3me5bi46/eo3vup4jd1srns5ao3qj8hkpm",
        glyphs : "mapbox://fonts/mapbox/{fontstack}/{range}.pbf",

        projection : {"name": "globe"},

        created : "2023-08-31T14:00:28.827Z",
        modified : "2023-08-31T14:04:54.252Z",
        id : "cllz8h5sr00nl01nz3me5bi46",
        owner : "rickard89",
        visibility : "private",
        protected : false,
        draft : false,

        layers: [

            {
                "id": "background",
                "type": "background",
                "metadata": {
                    "mapbox:featureComponent": "satellite",
                    "mapbox:group": "Satellite imagery, land"
                },
                "layout": {},
                "paint": {"background-color": "hsl(222, 56%, 4%)"}
            },

            {
                "id": "satellite",
                "type": "raster",
                "metadata": {
                    "mapbox:featureComponent": "satellite",
                    "mapbox:group": "Satellite imagery, land"
                },
                "source": "mapbox",
                "layout": {},
                "paint": {}
            },
        ]
    }
};

export {
    goolgeSettings,
    infoOptions,
    slickNavOptions,
    slickOptions,
    slickOptionsOpinion
};



// "layers": [


//     {
//         "id": "tunnel-path",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "walking-cycling",
//             "mapbox:group": "Walking, cycling, etc., tunnels"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 15,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "tunnel"],
//             ["==", ["get", "class"], "path"],
//             ["!=", ["get", "type"], "steps"],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {},
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 15,
//                 1,
//                 18,
//                 4
//             ],
//             "line-color": "hsla(40, 88%, 77%, 0.8)",
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 17,
//                 1,
//                 18,
//                 0
//             ],
//             "line-dasharray": [
//                 "step",
//                 ["zoom"],
//                 ["literal", [1, 0]],
//                 15,
//                 ["literal", [1.75, 1]],
//                 16,
//                 ["literal", [1, 0.75]],
//                 17,
//                 ["literal", [1, 0.5]]
//             ]
//         }
//     },
//     {
//         "id": "tunnel-steps",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "walking-cycling",
//             "mapbox:group": "Walking, cycling, etc., tunnels"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 15,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "tunnel"],
//             ["==", ["get", "type"], "steps"],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 15,
//                 1,
//                 16,
//                 1.6,
//                 18,
//                 6
//             ],
//             "line-color": "hsla(40, 88%, 77%, 0.8)",
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 17,
//                 1,
//                 18,
//                 0
//             ],
//             "line-dasharray": [
//                 "step",
//                 ["zoom"],
//                 ["literal", [1, 0]],
//                 15,
//                 ["literal", [1.75, 1]],
//                 16,
//                 ["literal", [1, 0.75]],
//                 17,
//                 ["literal", [0.3, 0.3]]
//             ]
//         }
//     },
//     {
//         "id": "tunnel-pedestrian",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "walking-cycling",
//             "mapbox:group": "Walking, cycling, etc., tunnels"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 15,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "tunnel"],
//             ["==", ["get", "class"], "pedestrian"],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 0.5,
//                 18,
//                 12
//             ],
//             "line-color": "hsla(40, 95%, 90%, 0.8)",
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 17,
//                 1,
//                 18,
//                 0
//             ],
//             "line-dasharray": [
//                 "step",
//                 ["zoom"],
//                 ["literal", [2, 0.3]],
//                 15,
//                 ["literal", [1, 0.3]],
//                 16,
//                 ["literal", [1, 0.3]],
//                 17,
//                 ["literal", [1, 0.25]]
//             ]
//         }
//     },
//     {
//         "id": "tunnel-minor-case",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, tunnels"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 13,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "tunnel"],
//             [
//                 "match",
//                 ["get", "class"],
//                 ["track"],
//                 true,
//                 "service",
//                 ["step", ["zoom"], false, 14, true],
//                 false
//             ],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 0.8,
//                 22,
//                 2
//             ],
//             "line-color": "hsla(0, 0%, 0%, 0.7)",
//             "line-gap-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 1,
//                 18,
//                 10,
//                 22,
//                 100
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ],
//             "line-dasharray": [3, 3]
//         }
//     },
//     {
//         "id": "tunnel-street-case",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, tunnels"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 14,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "tunnel"],
//             [
//                 "match",
//                 ["get", "class"],
//                 ["street", "street_limited"],
//                 true,
//                 false
//             ],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 0.8,
//                 22,
//                 2
//             ],
//             "line-color": "hsla(0, 0%, 0%, 0.7)",
//             "line-gap-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 12,
//                 0.5,
//                 18,
//                 20,
//                 22,
//                 200
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ],
//             "line-dasharray": [3, 3]
//         }
//     },
//     {
//         "id": "tunnel-minor-link-case",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, tunnels"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 13,
//         "filter": [
//             "all",
//             [
//                 "match",
//                 ["get", "class"],
//                 ["primary_link", "secondary_link", "tertiary_link"],
//                 true,
//                 false
//             ],
//             ["==", ["get", "structure"], "tunnel"],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {
//             "line-cap": ["step", ["zoom"], "butt", 14, "round"],
//             "line-join": ["step", ["zoom"], "miter", 14, "round"]
//         },
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 0.8,
//                 22,
//                 2
//             ],
//             "line-color": "hsla(0, 1%, 10%, 0.7)",
//             "line-gap-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 12,
//                 0.4,
//                 18,
//                 18,
//                 22,
//                 180
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "tunnel-secondary-tertiary-case",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, tunnels"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 11,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "tunnel"],
//             [
//                 "match",
//                 ["get", "class"],
//                 ["secondary", "tertiary"],
//                 true,
//                 false
//             ],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 1,
//                 22,
//                 2
//             ],
//             "line-color": "hsla(0, 0%, 0%, 0.7)",
//             "line-gap-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 3,
//                 0,
//                 18,
//                 26,
//                 22,
//                 260
//             ],
//             "line-dasharray": [3, 3],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 0.3,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "tunnel-primary-case",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, tunnels"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 10,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "tunnel"],
//             ["==", ["get", "class"], "primary"],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 1,
//                 22,
//                 2
//             ],
//             "line-color": "hsla(0, 0%, 0%, 0.7)",
//             "line-gap-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 3,
//                 0.8,
//                 18,
//                 28,
//                 22,
//                 280
//             ],
//             "line-dasharray": [3, 3],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 0.3,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "tunnel-major-link-case",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, tunnels"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 12,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "tunnel"],
//             [
//                 "match",
//                 ["get", "class"],
//                 ["motorway_link", "trunk_link"],
//                 true,
//                 false
//             ],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 0.8,
//                 22,
//                 2
//             ],
//             "line-color": "hsla(0, 0%, 80%, 0.8)",
//             "line-gap-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 12,
//                 0.8,
//                 18,
//                 20,
//                 22,
//                 200
//             ],
//             "line-dasharray": [3, 3],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "tunnel-motorway-trunk-case",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, tunnels"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 13,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "tunnel"],
//             ["match", ["get", "class"], ["motorway", "trunk"], true, false],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 1,
//                 22,
//                 2
//             ],
//             "line-color": "hsla(0, 1%, 22%, 0.7)",
//             "line-gap-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 3,
//                 0.8,
//                 18,
//                 30,
//                 22,
//                 300
//             ],
//             "line-dasharray": [3, 3],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "tunnel-minor",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, tunnels"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 13,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "tunnel"],
//             [
//                 "match",
//                 ["get", "class"],
//                 ["track"],
//                 true,
//                 "service",
//                 ["step", ["zoom"], false, 14, true],
//                 false
//             ],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 1,
//                 18,
//                 10,
//                 22,
//                 100
//             ],
//             "line-color": [
//                 "match",
//                 ["get", "class"],
//                 "street_limited",
//                 "hsl(0, 2%, 22%)",
//                 "hsla(0, 0%, 80%, 0.8)"
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "tunnel-minor-link",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, tunnels"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 13,
//         "filter": [
//             "all",
//             [
//                 "match",
//                 ["get", "class"],
//                 ["primary_link", "secondary_link", "tertiary_link"],
//                 true,
//                 false
//             ],
//             ["==", ["get", "structure"], "tunnel"],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {
//             "line-cap": ["step", ["zoom"], "butt", 13, "round"],
//             "line-join": ["step", ["zoom"], "miter", 13, "round"]
//         },
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 12,
//                 0.4,
//                 18,
//                 18,
//                 22,
//                 180
//             ],
//             "line-color": "hsla(0, 0%, 80%, 0.8)",
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "tunnel-major-link",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, tunnels"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 12,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "tunnel"],
//             [
//                 "match",
//                 ["get", "class"],
//                 ["motorway_link", "trunk_link"],
//                 true,
//                 false
//             ],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 12,
//                 0.8,
//                 18,
//                 20,
//                 22,
//                 200
//             ],
//             "line-color": [
//                 "match",
//                 ["get", "class"],
//                 "motorway_link",
//                 "hsla(30, 100%, 80%, 0.8)",
//                 "hsla(50, 78%, 80%, 0.8)"
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "tunnel-street",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, tunnels"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 13,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "tunnel"],
//             [
//                 "match",
//                 ["get", "class"],
//                 ["street", "street_limited"],
//                 true,
//                 false
//             ],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 12,
//                 0.5,
//                 18,
//                 20,
//                 22,
//                 200
//             ],
//             "line-color": [
//                 "match",
//                 ["get", "class"],
//                 "street_limited",
//                 "hsl(0, 2%, 22%)",
//                 "hsla(0, 0%, 80%, 0.8)"
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "tunnel-street-low",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, tunnels"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 13,
//         "maxzoom": 14,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "tunnel"],
//             [
//                 "match",
//                 ["get", "class"],
//                 ["street", "street_limited"],
//                 true,
//                 false
//             ],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {
//             "line-cap": ["step", ["zoom"], "butt", 14, "round"],
//             "line-join": ["step", ["zoom"], "miter", 14, "round"]
//         },
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 12,
//                 0.5,
//                 18,
//                 20,
//                 22,
//                 200
//             ],
//             "line-color": "hsla(0, 0%, 80%, 0.8)",
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 0.3,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "tunnel-secondary-tertiary",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, tunnels"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 13,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "tunnel"],
//             [
//                 "match",
//                 ["get", "class"],
//                 ["secondary", "tertiary"],
//                 true,
//                 false
//             ],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 3,
//                 0,
//                 18,
//                 26,
//                 22,
//                 260
//             ],
//             "line-color": "hsla(0, 0%, 80%, 0.8)",
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 0.3,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "tunnel-primary",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, tunnels"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 13,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "tunnel"],
//             ["==", ["get", "class"], "primary"],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 3,
//                 0.8,
//                 18,
//                 28,
//                 22,
//                 280
//             ],
//             "line-color": "hsla(0, 0%, 80%, 0.8)",
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 0.3,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "tunnel-motorway-trunk",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, tunnels"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 13,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "tunnel"],
//             ["match", ["get", "class"], ["motorway", "trunk"], true, false],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 3,
//                 0.8,
//                 18,
//                 30,
//                 22,
//                 300
//             ],
//             "line-color": [
//                 "match",
//                 ["get", "class"],
//                 "motorway",
//                 "hsla(30, 100%, 80%, 0.8)",
//                 "hsla(50, 78%, 80%, 0.8)"
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "road-path",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "walking-cycling",
//             "mapbox:group": "Walking, cycling, etc., surface"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 12,
//         "filter": [
//             "all",
//             ["==", ["get", "class"], "path"],
//             [
//                 "step",
//                 ["zoom"],
//                 [
//                     "!",
//                     [
//                         "match",
//                         ["get", "type"],
//                         ["steps", "sidewalk", "crossing"],
//                         true,
//                         false
//                     ]
//                 ],
//                 16,
//                 ["!=", ["get", "type"], "steps"]
//             ],
//             ["match", ["get", "structure"], ["none", "ford"], true, false],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {"line-join": ["step", ["zoom"], "miter", 14, "round"]},
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 13,
//                 0.5,
//                 14,
//                 1,
//                 15,
//                 1,
//                 18,
//                 4
//             ],
//             "line-color": "hsla(40, 95%, 90%, 0.8)",
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 17,
//                 1,
//                 18,
//                 0
//             ],
//             "line-dasharray": [
//                 "step",
//                 ["zoom"],
//                 ["literal", [4, 0.3]],
//                 15,
//                 ["literal", [1.75, 0.3]],
//                 16,
//                 ["literal", [1, 0.3]],
//                 17,
//                 ["literal", [1, 0.25]]
//             ]
//         }
//     },
//     {
//         "id": "road-steps",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "walking-cycling",
//             "mapbox:group": "Walking, cycling, etc., surface"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 14,
//         "filter": [
//             "all",
//             ["==", ["get", "type"], "steps"],
//             ["match", ["get", "structure"], ["none", "ford"], true, false],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {"line-join": "round"},
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 15,
//                 1,
//                 16,
//                 1.6,
//                 18,
//                 6
//             ],
//             "line-color": "hsla(40, 95%, 90%, 0.8)",
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 17,
//                 1,
//                 18,
//                 0
//             ],
//             "line-dasharray": [
//                 "step",
//                 ["zoom"],
//                 ["literal", [1, 0]],
//                 15,
//                 ["literal", [1.75, 1]],
//                 16,
//                 ["literal", [1, 0.75]],
//                 17,
//                 ["literal", [0.3, 0.3]]
//             ]
//         }
//     },
//     {
//         "id": "road-pedestrian",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "walking-cycling",
//             "mapbox:group": "Walking, cycling, etc., surface"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 12,
//         "filter": [
//             "all",
//             ["==", ["get", "class"], "pedestrian"],
//             ["match", ["get", "structure"], ["none", "ford"], true, false],
//             ["case", ["has", "layer"], [">=", ["get", "layer"], 0], true],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {"line-join": ["step", ["zoom"], "miter", 14, "round"]},
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 0.5,
//                 18,
//                 12
//             ],
//             "line-color": "hsla(40, 95%, 90%, 0.8)",
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 17,
//                 1,
//                 18,
//                 0
//             ],
//             "line-dasharray": [
//                 "step",
//                 ["zoom"],
//                 ["literal", [2, 0.3]],
//                 15,
//                 ["literal", [1, 0.3]],
//                 16,
//                 ["literal", [1, 0.3]],
//                 17,
//                 ["literal", [1, 0.25]]
//             ]
//         }
//     },
//     {
//         "id": "road-minor-case",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, surface"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 13,
//         "filter": [
//             "all",
//             [
//                 "match",
//                 ["get", "class"],
//                 ["track"],
//                 true,
//                 "service",
//                 ["step", ["zoom"], false, 14, true],
//                 false
//             ],
//             ["match", ["get", "structure"], ["none", "ford"], true, false],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {
//             "line-cap": ["step", ["zoom"], "butt", 14, "round"],
//             "line-join": ["step", ["zoom"], "miter", 14, "round"]
//         },
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 0.8,
//                 22,
//                 2
//             ],
//             "line-color": [
//                 "match",
//                 ["get", "class"],
//                 "track",
//                 "hsla(40, 95%, 90%, 0.8)",
//                 "hsla(0, 1%, 10%, 0.7)"
//             ],
//             "line-gap-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 1,
//                 18,
//                 10,
//                 22,
//                 100
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "road-street-case",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, surface"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 14,
//         "filter": [
//             "all",
//             [
//                 "match",
//                 ["get", "class"],
//                 ["street", "street_limited"],
//                 true,
//                 false
//             ],
//             ["match", ["get", "structure"], ["none", "ford"], true, false],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {
//             "line-cap": ["step", ["zoom"], "butt", 14, "round"],
//             "line-join": ["step", ["zoom"], "miter", 14, "round"]
//         },
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 0.8,
//                 22,
//                 2
//             ],
//             "line-color": "hsla(0, 1%, 10%, 0.7)",
//             "line-gap-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 12,
//                 0.5,
//                 18,
//                 20,
//                 22,
//                 200
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 0.3,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "road-minor-link-case",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, surface"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 13,
//         "filter": [
//             "all",
//             [
//                 "match",
//                 ["get", "class"],
//                 ["primary_link", "secondary_link", "tertiary_link"],
//                 true,
//                 false
//             ],
//             ["match", ["get", "structure"], ["none", "ford"], true, false],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {
//             "line-cap": ["step", ["zoom"], "butt", 14, "round"],
//             "line-join": ["step", ["zoom"], "miter", 14, "round"]
//         },
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 0.8,
//                 22,
//                 2
//             ],
//             "line-color": "hsla(0, 1%, 10%, 0.7)",
//             "line-gap-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 12,
//                 0.4,
//                 18,
//                 18,
//                 22,
//                 180
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "road-secondary-tertiary-case",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, surface"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 11,
//         "filter": [
//             "all",
//             [
//                 "match",
//                 ["get", "class"],
//                 ["secondary", "tertiary"],
//                 true,
//                 false
//             ],
//             ["match", ["get", "structure"], ["none", "ford"], true, false],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {
//             "line-cap": ["step", ["zoom"], "butt", 14, "round"],
//             "line-join": ["step", ["zoom"], "miter", 14, "round"]
//         },
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 0.8,
//                 22,
//                 2
//             ],
//             "line-color": "hsla(0, 1%, 10%, 0.7)",
//             "line-gap-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 3,
//                 0,
//                 18,
//                 26,
//                 22,
//                 260
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 0.3,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "road-primary-case",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, surface"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 10,
//         "filter": [
//             "all",
//             ["==", ["get", "class"], "primary"],
//             ["match", ["get", "structure"], ["none", "ford"], true, false],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {
//             "line-cap": ["step", ["zoom"], "butt", 14, "round"],
//             "line-join": ["step", ["zoom"], "miter", 14, "round"]
//         },
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 1,
//                 22,
//                 2
//             ],
//             "line-color": "hsla(0, 1%, 10%, 0.7)",
//             "line-gap-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 3,
//                 0.8,
//                 18,
//                 28,
//                 22,
//                 280
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "road-major-link-case",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, surface"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 12,
//         "filter": [
//             "all",
//             [
//                 "match",
//                 ["get", "class"],
//                 ["motorway_link", "trunk_link"],
//                 true,
//                 false
//             ],
//             ["match", ["get", "structure"], ["none", "ford"], true, false],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {
//             "line-cap": ["step", ["zoom"], "butt", 14, "round"],
//             "line-join": ["step", ["zoom"], "miter", 14, "round"]
//         },
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 0.8,
//                 22,
//                 2
//             ],
//             "line-color": "hsla(0, 1%, 22%, 0.7)",
//             "line-gap-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 12,
//                 0.8,
//                 18,
//                 20,
//                 22,
//                 200
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "road-motorway-trunk-case",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, surface"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 3,
//         "filter": [
//             "all",
//             [
//                 "step",
//                 ["zoom"],
//                 [
//                     "match",
//                     ["get", "class"],
//                     ["motorway", "trunk"],
//                     true,
//                     false
//                 ],
//                 5,
//                 [
//                     "all",
//                     [
//                         "match",
//                         ["get", "class"],
//                         ["motorway", "trunk"],
//                         true,
//                         false
//                     ],
//                     [
//                         "match",
//                         ["get", "structure"],
//                         ["none", "ford"],
//                         true,
//                         false
//                     ]
//                 ]
//             ],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {
//             "line-cap": ["step", ["zoom"], "butt", 14, "round"],
//             "line-join": ["step", ["zoom"], "miter", 14, "round"]
//         },
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 1,
//                 22,
//                 2
//             ],
//             "line-color": "hsla(0, 1%, 22%, 0.7)",
//             "line-gap-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 3,
//                 0.8,
//                 18,
//                 30,
//                 22,
//                 300
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 3,
//                 0,
//                 3.5,
//                 1,
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "road-minor",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, surface"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 13,
//         "filter": [
//             "all",
//             [
//                 "match",
//                 ["get", "class"],
//                 ["track"],
//                 true,
//                 "service",
//                 ["step", ["zoom"], false, 14, true],
//                 false
//             ],
//             ["match", ["get", "structure"], ["none", "ford"], true, false],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {
//             "line-cap": ["step", ["zoom"], "butt", 14, "round"],
//             "line-join": ["step", ["zoom"], "miter", 14, "round"]
//         },
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 1,
//                 18,
//                 10,
//                 22,
//                 100
//             ],
//             "line-color": "hsla(0, 0%, 80%, 0.8)",
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "road-minor-link",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, surface"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 12,
//         "filter": [
//             "all",
//             [
//                 "match",
//                 ["get", "class"],
//                 ["primary_link", "secondary_link", "tertiary_link"],
//                 true,
//                 false
//             ],
//             ["match", ["get", "structure"], ["none", "ford"], true, false],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {
//             "line-cap": ["step", ["zoom"], "butt", 13, "round"],
//             "line-join": ["step", ["zoom"], "miter", 13, "round"]
//         },
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 12,
//                 0.4,
//                 18,
//                 18,
//                 22,
//                 180
//             ],
//             "line-color": "hsla(0, 0%, 80%, 0.8)",
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "road-major-link",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, surface"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 12,
//         "filter": [
//             "all",
//             [
//                 "match",
//                 ["get", "class"],
//                 ["motorway_link", "trunk_link"],
//                 true,
//                 false
//             ],
//             ["match", ["get", "structure"], ["none", "ford"], true, false],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {
//             "line-cap": ["step", ["zoom"], "butt", 13, "round"],
//             "line-join": ["step", ["zoom"], "miter", 13, "round"]
//         },
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 12,
//                 0.8,
//                 18,
//                 20,
//                 22,
//                 200
//             ],
//             "line-color": [
//                 "match",
//                 ["get", "class"],
//                 "motorway_link",
//                 "hsla(30, 100%, 70%, 0.8)",
//                 "hsla(50, 89%, 70%, 0.8)"
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "road-street",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, surface"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 13,
//         "filter": [
//             "all",
//             [
//                 "match",
//                 ["get", "class"],
//                 ["street", "street_limited"],
//                 true,
//                 false
//             ],
//             ["match", ["get", "structure"], ["none", "ford"], true, false],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {
//             "line-cap": ["step", ["zoom"], "butt", 14, "round"],
//             "line-join": ["step", ["zoom"], "miter", 14, "round"]
//         },
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 12,
//                 0.5,
//                 18,
//                 20,
//                 22,
//                 200
//             ],
//             "line-color": [
//                 "match",
//                 ["get", "class"],
//                 "street_limited",
//                 "hsl(0, 2%, 22%)",
//                 "hsla(0, 0%, 80%, 0.8)"
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 0.3,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "road-street-low",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, surface"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 11,
//         "maxzoom": 14,
//         "filter": [
//             "all",
//             [
//                 "match",
//                 ["get", "class"],
//                 ["street", "street_limited"],
//                 true,
//                 false
//             ],
//             ["match", ["get", "structure"], ["none", "ford"], true, false],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {
//             "line-cap": ["step", ["zoom"], "butt", 14, "round"],
//             "line-join": ["step", ["zoom"], "miter", 14, "round"]
//         },
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 12,
//                 0.5,
//                 18,
//                 20,
//                 22,
//                 200
//             ],
//             "line-color": "hsla(0, 0%, 80%, 0.8)",
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 0.3,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "road-secondary-tertiary",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, surface"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 9,
//         "filter": [
//             "all",
//             [
//                 "match",
//                 ["get", "class"],
//                 ["secondary", "tertiary"],
//                 true,
//                 false
//             ],
//             ["match", ["get", "structure"], ["none", "ford"], true, false],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {
//             "line-cap": ["step", ["zoom"], "butt", 14, "round"],
//             "line-join": ["step", ["zoom"], "miter", 14, "round"]
//         },
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 3,
//                 0,
//                 18,
//                 26,
//                 22,
//                 260
//             ],
//             "line-color": "hsla(0, 0%, 80%, 0.8)",
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 0.3,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "road-primary",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, surface"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 6,
//         "filter": [
//             "all",
//             ["==", ["get", "class"], "primary"],
//             ["match", ["get", "structure"], ["none", "ford"], true, false],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {
//             "line-cap": ["step", ["zoom"], "butt", 14, "round"],
//             "line-join": ["step", ["zoom"], "miter", 14, "round"]
//         },
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 3,
//                 0.8,
//                 18,
//                 28,
//                 22,
//                 280
//             ],
//             "line-color": "hsla(0, 0%, 80%, 0.8)",
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "road-motorway-trunk",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, surface"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 3,
//         "filter": [
//             "all",
//             [
//                 "step",
//                 ["zoom"],
//                 [
//                     "match",
//                     ["get", "class"],
//                     ["motorway", "trunk"],
//                     true,
//                     false
//                 ],
//                 5,
//                 [
//                     "all",
//                     [
//                         "match",
//                         ["get", "class"],
//                         ["motorway", "trunk"],
//                         true,
//                         false
//                     ],
//                     [
//                         "match",
//                         ["get", "structure"],
//                         ["none", "ford"],
//                         true,
//                         false
//                     ]
//                 ]
//             ],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {
//             "line-cap": ["step", ["zoom"], "butt", 13, "round"],
//             "line-join": ["step", ["zoom"], "miter", 13, "round"]
//         },
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 3,
//                 0.8,
//                 18,
//                 30,
//                 22,
//                 300
//             ],
//             "line-color": [
//                 "step",
//                 ["zoom"],
//                 [
//                     "match",
//                     ["get", "class"],
//                     "motorway",
//                     "hsla(30, 88%, 64%, 0.8)",
//                     "trunk",
//                     "hsla(50, 81%, 54%, 0.8)",
//                     "hsl(0, 0%, 22%)"
//                 ],
//                 9,
//                 [
//                     "match",
//                     ["get", "class"],
//                     "motorway",
//                     "hsla(30, 100%, 70%, 0.8)",
//                     "hsla(50, 89%, 70%, 0.8)"
//                 ]
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 3,
//                 0,
//                 3.5,
//                 1,
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "bridge-path",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "walking-cycling",
//             "mapbox:group": "Walking, cycling, etc., barriers-bridges"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 14,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "bridge"],
//             ["==", ["get", "class"], "path"],
//             ["!=", ["get", "type"], "steps"],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {},
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 15,
//                 1,
//                 18,
//                 4
//             ],
//             "line-color": "hsla(40, 95%, 90%, 0.8)",
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 17,
//                 1,
//                 18,
//                 0
//             ],
//             "line-dasharray": [
//                 "step",
//                 ["zoom"],
//                 ["literal", [4, 0.3]],
//                 15,
//                 ["literal", [1.75, 0.3]],
//                 16,
//                 ["literal", [1, 0.3]],
//                 17,
//                 ["literal", [1, 0.25]]
//             ]
//         }
//     },
//     {
//         "id": "bridge-steps",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "walking-cycling",
//             "mapbox:group": "Walking, cycling, etc., barriers-bridges"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 14,
//         "filter": [
//             "all",
//             ["==", ["get", "type"], "steps"],
//             ["==", ["get", "structure"], "bridge"],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 15,
//                 1,
//                 16,
//                 1.6,
//                 18,
//                 6
//             ],
//             "line-color": "hsla(40, 95%, 90%, 0.8)",
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 17,
//                 1,
//                 18,
//                 0
//             ],
//             "line-dasharray": [
//                 "step",
//                 ["zoom"],
//                 ["literal", [1, 0]],
//                 15,
//                 ["literal", [1.75, 1]],
//                 16,
//                 ["literal", [1, 0.75]],
//                 17,
//                 ["literal", [0.3, 0.3]]
//             ]
//         }
//     },
//     {
//         "id": "bridge-pedestrian",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "walking-cycling",
//             "mapbox:group": "Walking, cycling, etc., barriers-bridges"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 13,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "bridge"],
//             ["==", ["get", "class"], "pedestrian"],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 0.5,
//                 18,
//                 12
//             ],
//             "line-color": "hsla(40, 95%, 90%, 0.8)",
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 17,
//                 1,
//                 18,
//                 0
//             ],
//             "line-dasharray": [
//                 "step",
//                 ["zoom"],
//                 ["literal", [2, 0.3]],
//                 15,
//                 ["literal", [1, 0.3]],
//                 16,
//                 ["literal", [1, 0.3]],
//                 17,
//                 ["literal", [1, 0.25]]
//             ]
//         }
//     },
//     {
//         "id": "bridge-minor-case",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, bridges"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 13,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "bridge"],
//             [
//                 "match",
//                 ["get", "class"],
//                 ["track"],
//                 true,
//                 "service",
//                 ["step", ["zoom"], false, 14, true],
//                 false
//             ],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 0.8,
//                 22,
//                 2
//             ],
//             "line-color": [
//                 "match",
//                 ["get", "class"],
//                 "track",
//                 "hsla(40, 95%, 90%, 0.8)",
//                 "hsla(0, 1%, 10%, 0.7)"
//             ],
//             "line-gap-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 1,
//                 18,
//                 10,
//                 22,
//                 100
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "bridge-street-case",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, bridges"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 14,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "bridge"],
//             [
//                 "match",
//                 ["get", "class"],
//                 ["street", "street_limited"],
//                 true,
//                 false
//             ],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 0.8,
//                 22,
//                 2
//             ],
//             "line-color": [
//                 "match",
//                 ["get", "class"],
//                 "track",
//                 "hsla(40, 95%, 90%, 0.8)",
//                 "hsla(0, 1%, 10%, 0.7)"
//             ],
//             "line-gap-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 12,
//                 0.5,
//                 18,
//                 20,
//                 22,
//                 200
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "bridge-minor-link-case",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, bridges"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 13,
//         "filter": [
//             "all",
//             [
//                 "match",
//                 ["get", "class"],
//                 ["primary_link", "secondary_link", "tertiary_link"],
//                 true,
//                 false
//             ],
//             ["==", ["get", "structure"], "bridge"],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {"line-join": ["step", ["zoom"], "miter", 14, "round"]},
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 0.8,
//                 22,
//                 2
//             ],
//             "line-color": "hsla(0, 1%, 10%, 0.7)",
//             "line-gap-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 12,
//                 0.4,
//                 18,
//                 18,
//                 22,
//                 180
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "bridge-secondary-tertiary-case",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, bridges"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 11,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "bridge"],
//             [
//                 "match",
//                 ["get", "class"],
//                 ["secondary", "tertiary"],
//                 true,
//                 false
//             ],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 1,
//                 22,
//                 2
//             ],
//             "line-color": "hsla(0, 1%, 10%, 0.7)",
//             "line-gap-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 3,
//                 0,
//                 18,
//                 26,
//                 22,
//                 260
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 0.3,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "bridge-primary-case",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, bridges"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 10,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "bridge"],
//             ["==", ["get", "class"], "primary"],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 1,
//                 22,
//                 2
//             ],
//             "line-color": "hsla(0, 1%, 10%, 0.7)",
//             "line-gap-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 3,
//                 0.8,
//                 18,
//                 28,
//                 22,
//                 280
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 0.3,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "bridge-major-link-case",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, bridges"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 12,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "bridge"],
//             [
//                 "match",
//                 ["get", "class"],
//                 ["motorway_link", "trunk_link"],
//                 true,
//                 false
//             ],
//             ["<=", ["get", "layer"], 1],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 0.8,
//                 22,
//                 2
//             ],
//             "line-color": "hsla(0, 1%, 22%, 0.7)",
//             "line-gap-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 12,
//                 0.8,
//                 18,
//                 20,
//                 22,
//                 200
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "bridge-motorway-trunk-case",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, bridges"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 13,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "bridge"],
//             ["match", ["get", "class"], ["motorway", "trunk"], true, false],
//             ["<=", ["get", "layer"], 1],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 1,
//                 22,
//                 2
//             ],
//             "line-color": "hsla(0, 1%, 22%, 0.7)",
//             "line-gap-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 3,
//                 0.8,
//                 18,
//                 30,
//                 22,
//                 300
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "bridge-minor",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, bridges"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 13,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "bridge"],
//             [
//                 "match",
//                 ["get", "class"],
//                 ["track"],
//                 true,
//                 "service",
//                 ["step", ["zoom"], false, 14, true],
//                 false
//             ],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {"line-cap": ["step", ["zoom"], "butt", 14, "round"]},
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 1,
//                 18,
//                 10,
//                 22,
//                 100
//             ],
//             "line-color": "hsla(0, 0%, 80%, 0.8)",
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "bridge-minor-link",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, bridges"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 13,
//         "filter": [
//             "all",
//             [
//                 "match",
//                 ["get", "class"],
//                 ["primary_link", "secondary_link", "tertiary_link"],
//                 true,
//                 false
//             ],
//             ["==", ["get", "structure"], "bridge"],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {"line-cap": ["step", ["zoom"], "butt", 14, "round"]},
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 12,
//                 0.4,
//                 18,
//                 18,
//                 22,
//                 180
//             ],
//             "line-color": "hsla(0, 0%, 80%, 0.8)",
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "bridge-major-link",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, bridges"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 12,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "bridge"],
//             [
//                 "match",
//                 ["get", "class"],
//                 ["motorway_link", "trunk_link"],
//                 true,
//                 false
//             ],
//             ["<=", ["get", "layer"], 1],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {"line-cap": ["step", ["zoom"], "butt", 13, "round"]},
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 12,
//                 0.8,
//                 18,
//                 20,
//                 22,
//                 200
//             ],
//             "line-color": [
//                 "match",
//                 ["get", "class"],
//                 "motorway_link",
//                 "hsla(30, 100%, 70%, 0.8)",
//                 "hsla(50, 89%, 70%, 0.8)"
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "bridge-street",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, bridges"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 13,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "bridge"],
//             [
//                 "match",
//                 ["get", "class"],
//                 ["street", "street_limited"],
//                 true,
//                 false
//             ],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {"line-cap": ["step", ["zoom"], "butt", 14, "round"]},
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 12,
//                 0.5,
//                 18,
//                 20,
//                 22,
//                 200
//             ],
//             "line-color": [
//                 "match",
//                 ["get", "class"],
//                 "street_limited",
//                 "hsl(0, 2%, 22%)",
//                 "hsla(0, 0%, 80%, 0.8)"
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "bridge-street-low",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, bridges"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 13,
//         "maxzoom": 14,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "bridge"],
//             [
//                 "match",
//                 ["get", "class"],
//                 ["street", "street_limited"],
//                 true,
//                 false
//             ],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {
//             "line-cap": ["step", ["zoom"], "butt", 14, "round"],
//             "line-join": ["step", ["zoom"], "miter", 14, "round"]
//         },
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 12,
//                 0.5,
//                 18,
//                 20,
//                 22,
//                 200
//             ],
//             "line-color": "hsla(0, 0%, 80%, 0.8)",
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 0.3,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "bridge-secondary-tertiary",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, bridges"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 13,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "bridge"],
//             [
//                 "match",
//                 ["get", "class"],
//                 ["secondary", "tertiary"],
//                 true,
//                 false
//             ],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {"line-cap": ["step", ["zoom"], "butt", 14, "round"]},
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 3,
//                 0,
//                 18,
//                 26,
//                 22,
//                 260
//             ],
//             "line-color": "hsla(0, 0%, 80%, 0.8)",
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 0.3,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "bridge-primary",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, bridges"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 13,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "bridge"],
//             ["==", ["get", "class"], "primary"],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {"line-cap": ["step", ["zoom"], "butt", 14, "round"]},
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 3,
//                 0.8,
//                 18,
//                 28,
//                 22,
//                 280
//             ],
//             "line-color": "hsla(0, 0%, 80%, 0.8)",
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 0.3,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "bridge-motorway-trunk",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, bridges"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 13,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "bridge"],
//             ["match", ["get", "class"], ["motorway", "trunk"], true, false],
//             ["<=", ["get", "layer"], 1],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {"line-cap": ["step", ["zoom"], "butt", 14, "round"]},
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 3,
//                 0.8,
//                 18,
//                 30,
//                 22,
//                 300
//             ],
//             "line-color": [
//                 "match",
//                 ["get", "class"],
//                 "motorway",
//                 "hsla(30, 100%, 70%, 0.8)",
//                 "hsla(50, 89%, 70%, 0.8)"
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "bridge-major-link-2-case",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, bridges"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 12,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "bridge"],
//             [">=", ["get", "layer"], 2],
//             [
//                 "match",
//                 ["get", "class"],
//                 ["motorway_link", "trunk_link"],
//                 true,
//                 false
//             ],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 0.8,
//                 22,
//                 2
//             ],
//             "line-color": "hsla(0, 1%, 22%, 0.7)",
//             "line-gap-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 12,
//                 0.8,
//                 18,
//                 20,
//                 22,
//                 200
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "bridge-motorway-trunk-2-case",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, bridges"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 13,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "bridge"],
//             [">=", ["get", "layer"], 2],
//             ["match", ["get", "class"], ["motorway", "trunk"], true, false],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 1,
//                 22,
//                 2
//             ],
//             "line-color": "hsla(0, 1%, 22%, 0.7)",
//             "line-gap-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 3,
//                 0.8,
//                 18,
//                 30,
//                 22,
//                 300
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "bridge-major-link-2",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, bridges"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 12,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "bridge"],
//             [">=", ["get", "layer"], 2],
//             [
//                 "match",
//                 ["get", "class"],
//                 ["motorway_link", "trunk_link"],
//                 true,
//                 false
//             ],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {"line-cap": ["step", ["zoom"], "butt", 13, "round"]},
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 12,
//                 0.8,
//                 18,
//                 20,
//                 22,
//                 200
//             ],
//             "line-color": [
//                 "match",
//                 ["get", "class"],
//                 "motorway_link",
//                 "hsla(30, 100%, 70%, 0.8)",
//                 "hsla(50, 89%, 70%, 0.8)"
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "bridge-motorway-trunk-2",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, bridges"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 13,
//         "filter": [
//             "all",
//             ["==", ["get", "structure"], "bridge"],
//             [">=", ["get", "layer"], 2],
//             ["match", ["get", "class"], ["motorway", "trunk"], true, false],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {"line-cap": ["step", ["zoom"], "butt", 14, "round"]},
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 3,
//                 0.8,
//                 18,
//                 30,
//                 22,
//                 300
//             ],
//             "line-color": [
//                 "match",
//                 ["get", "class"],
//                 "motorway",
//                 "hsla(30, 100%, 70%, 0.8)",
//                 "hsla(50, 89%, 70%, 0.8)"
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 1,
//                 15,
//                 0
//             ]
//         }
//     },
//     {
//         "id": "aerialway",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "transit",
//             "mapbox:group": "Transit, bridges"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 12,
//         "filter": ["==", ["get", "class"], "aerialway"],
//         "paint": {
//             "line-color": "hsl(204, 100%, 80%)",
//             "line-width": [
//                 "interpolate",
//                 ["exponential", 1.5],
//                 ["zoom"],
//                 14,
//                 1,
//                 20,
//                 2
//             ],
//             "line-dasharray": [4, 1]
//         }
//     },
//     {
//         "id": "admin-1-boundary-bg",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "admin-boundaries",
//             "mapbox:group": "Administrative boundaries, admin"
//         },
//         "source": "composite",
//         "source-layer": "admin",
//         "minzoom": 7,
//         "filter": [
//             "all",
//             ["==", ["get", "admin_level"], 1],
//             ["==", ["get", "maritime"], "false"],
//             ["match", ["get", "worldview"], ["all", "US"], true, false]
//         ],
//         "paint": {
//             "line-color": "hsl(260, 45%, 0%)",
//             "line-width": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 3,
//                 3,
//                 12,
//                 6
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 7,
//                 0,
//                 8,
//                 0.5
//             ],
//             "line-dasharray": [1, 0],
//             "line-blur": ["interpolate", ["linear"], ["zoom"], 3, 0, 12, 3]
//         }
//     },
//     {
//         "id": "admin-0-boundary-bg",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "admin-boundaries",
//             "mapbox:group": "Administrative boundaries, admin"
//         },
//         "source": "composite",
//         "source-layer": "admin",
//         "minzoom": 1,
//         "filter": [
//             "all",
//             ["==", ["get", "admin_level"], 0],
//             ["==", ["get", "maritime"], "false"],
//             ["match", ["get", "worldview"], ["all", "US"], true, false]
//         ],
//         "paint": {
//             "line-width": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 3,
//                 6,
//                 12,
//                 12
//             ],
//             "line-color": "hsl(260, 45%, 0%)",
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 3,
//                 0,
//                 4,
//                 0.5
//             ],
//             "line-blur": ["interpolate", ["linear"], ["zoom"], 3, 0, 12, 3]
//         }
//     },
//     {
//         "id": "admin-1-boundary",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "admin-boundaries",
//             "mapbox:group": "Administrative boundaries, admin"
//         },
//         "source": "composite",
//         "source-layer": "admin",
//         "minzoom": 2,
//         "filter": [
//             "all",
//             ["==", ["get", "admin_level"], 1],
//             ["==", ["get", "maritime"], "false"],
//             ["match", ["get", "worldview"], ["all", "US"], true, false]
//         ],
//         "layout": {},
//         "paint": {
//             "line-dasharray": [
//                 "step",
//                 ["zoom"],
//                 ["literal", [2, 0]],
//                 7,
//                 ["literal", [2, 2, 6, 2]]
//             ],
//             "line-width": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 3,
//                 0.3,
//                 12,
//                 1.5
//             ],
//             "line-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 2,
//                 0,
//                 3,
//                 1
//             ],
//             "line-color": "hsl(260, 15%, 85%)"
//         }
//     },
//     {
//         "id": "admin-0-boundary",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "admin-boundaries",
//             "mapbox:group": "Administrative boundaries, admin"
//         },
//         "source": "composite",
//         "source-layer": "admin",
//         "minzoom": 1,
//         "filter": [
//             "all",
//             ["==", ["get", "admin_level"], 0],
//             ["==", ["get", "disputed"], "false"],
//             ["==", ["get", "maritime"], "false"],
//             ["match", ["get", "worldview"], ["all", "US"], true, false]
//         ],
//         "layout": {},
//         "paint": {
//             "line-color": "hsl(260, 15%, 80%)",
//             "line-width": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 3,
//                 0.75,
//                 12,
//                 3
//             ],
//             "line-dasharray": [
//                 "step",
//                 ["zoom"],
//                 ["literal", [2, 0]],
//                 7,
//                 ["literal", [2, 2, 6, 2]]
//             ]
//         }
//     },
//     {
//         "id": "admin-0-boundary-disputed",
//         "type": "line",
//         "metadata": {
//             "mapbox:featureComponent": "admin-boundaries",
//             "mapbox:group": "Administrative boundaries, admin"
//         },
//         "source": "composite",
//         "source-layer": "admin",
//         "minzoom": 1,
//         "filter": [
//             "all",
//             ["==", ["get", "disputed"], "true"],
//             ["==", ["get", "admin_level"], 0],
//             ["==", ["get", "maritime"], "false"],
//             ["match", ["get", "worldview"], ["all", "US"], true, false]
//         ],
//         "paint": {
//             "line-color": "hsl(260, 15%, 80%)",
//             "line-width": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 3,
//                 0.75,
//                 12,
//                 3
//             ],
//             "line-dasharray": [
//                 "step",
//                 ["zoom"],
//                 ["literal", [3, 2, 5]],
//                 7,
//                 ["literal", [2, 1.5]]
//             ]
//         }
//     },
//     {
//         "id": "road-label",
//         "type": "symbol",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, road-labels"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 10,
//         "filter": [
//             "all",
//             ["has", "name"],
//             [
//                 "step",
//                 ["zoom"],
//                 [
//                     "match",
//                     ["get", "class"],
//                     [
//                         "motorway",
//                         "trunk",
//                         "primary",
//                         "secondary",
//                         "tertiary"
//                     ],
//                     true,
//                     false
//                 ],
//                 12,
//                 [
//                     "match",
//                     ["get", "class"],
//                     [
//                         "motorway",
//                         "trunk",
//                         "primary",
//                         "secondary",
//                         "tertiary",
//                         "street",
//                         "street_limited"
//                     ],
//                     true,
//                     false
//                 ],
//                 15,
//                 [
//                     "match",
//                     ["get", "class"],
//                     ["path", "pedestrian", "golf", "ferry", "aerialway"],
//                     false,
//                     true
//                 ]
//             ],
//             [
//                 "step",
//                 ["pitch"],
//                 true,
//                 50,
//                 ["<", ["distance-from-center"], 2],
//                 60,
//                 ["<", ["distance-from-center"], 2.5],
//                 70,
//                 ["<", ["distance-from-center"], 3]
//             ]
//         ],
//         "layout": {
//             "text-size": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 10,
//                 [
//                     "match",
//                     ["get", "class"],
//                     [
//                         "motorway",
//                         "trunk",
//                         "primary",
//                         "secondary",
//                         "tertiary"
//                     ],
//                     11,
//                     [
//                         "motorway_link",
//                         "trunk_link",
//                         "primary_link",
//                         "secondary_link",
//                         "tertiary_link",
//                         "street",
//                         "street_limited"
//                     ],
//                     9.9,
//                     7.15
//                 ],
//                 18,
//                 [
//                     "match",
//                     ["get", "class"],
//                     [
//                         "motorway",
//                         "trunk",
//                         "primary",
//                         "secondary",
//                         "tertiary"
//                     ],
//                     17.6,
//                     [
//                         "motorway_link",
//                         "trunk_link",
//                         "primary_link",
//                         "secondary_link",
//                         "tertiary_link",
//                         "street",
//                         "street_limited"
//                     ],
//                     15.400000000000002,
//                     14.3
//                 ]
//             ],
//             "text-max-angle": 30,
//             "text-font": ["DIN Pro Medium", "Arial Unicode MS Regular"],
//             "symbol-placement": "line",
//             "text-padding": 5,
//             "text-rotation-alignment": "map",
//             "text-pitch-alignment": "viewport",
//             "text-field": ["coalesce", ["get", "name_en"], ["get", "name"]],
//             "text-letter-spacing": 0.01
//         },
//         "paint": {
//             "text-color": "hsl(0, 0%, 100%)",
//             "text-halo-color": [
//                 "match",
//                 ["get", "class"],
//                 ["motorway", "trunk"],
//                 "hsla(0, 5%, 0%, 0.75)",
//                 "hsl(0, 5%, 0%)"
//             ],
//             "text-halo-width": 1,
//             "text-halo-blur": 1
//         }
//     },
//     {
//         "id": "road-intersection",
//         "type": "symbol",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, road-labels"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 15,
//         "filter": [
//             "all",
//             ["==", ["get", "class"], "intersection"],
//             ["has", "name"],
//             [
//                 "step",
//                 ["pitch"],
//                 true,
//                 50,
//                 ["<", ["distance-from-center"], 1],
//                 60,
//                 ["<", ["distance-from-center"], 1.5],
//                 70,
//                 ["<", ["distance-from-center"], 2]
//             ]
//         ],
//         "layout": {
//             "text-field": ["coalesce", ["get", "name_en"], ["get", "name"]],
//             "icon-image": "intersection",
//             "icon-text-fit": "both",
//             "icon-text-fit-padding": [1, 2, 1, 2],
//             "text-size": [
//                 "interpolate",
//                 ["exponential", 1.2],
//                 ["zoom"],
//                 15,
//                 9,
//                 18,
//                 12
//             ],
//             "text-font": ["DIN Pro Bold", "Arial Unicode MS Bold"]
//         },
//         "paint": {"text-color": "hsl(230, 36%, 64%)"}
//     },
//     {
//         "id": "road-number-shield",
//         "type": "symbol",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, road-labels"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 6,
//         "filter": [
//             "all",
//             [
//                 "case",
//                 ["has", "reflen"],
//                 ["<=", ["get", "reflen"], 6],
//                 ["has", "shield_beta"]
//             ],
//             [
//                 "match",
//                 ["get", "class"],
//                 ["pedestrian", "service"],
//                 false,
//                 true
//             ],
//             [
//                 "step",
//                 ["zoom"],
//                 ["==", ["geometry-type"], "Point"],
//                 11,
//                 [">", ["get", "len"], 5000],
//                 12,
//                 [">", ["get", "len"], 2500],
//                 13,
//                 [">", ["get", "len"], 1000],
//                 14,
//                 true
//             ],
//             [
//                 "step",
//                 ["pitch"],
//                 true,
//                 50,
//                 ["<", ["distance-from-center"], 2],
//                 60,
//                 ["<", ["distance-from-center"], 2.5],
//                 70,
//                 ["<", ["distance-from-center"], 3]
//             ]
//         ],
//         "layout": {
//             "text-size": 9,
//             "icon-image": [
//                 "case",
//                 ["has", "shield_beta"],
//                 [
//                     "coalesce",
//                     [
//                         "image",
//                         [
//                             "concat",
//                             ["get", "shield_beta"],
//                             "-",
//                             ["to-string", ["get", "reflen"]]
//                         ]
//                     ],
//                     [
//                         "image",
//                         [
//                             "concat",
//                             ["get", "shield"],
//                             "-",
//                             ["to-string", ["get", "reflen"]]
//                         ]
//                     ],
//                     [
//                         "image",
//                         [
//                             "concat",
//                             "default-",
//                             ["to-string", ["get", "reflen"]]
//                         ]
//                     ]
//                 ],
//                 [
//                     "concat",
//                     ["get", "shield"],
//                     "-",
//                     ["to-string", ["get", "reflen"]]
//                 ]
//             ],
//             "icon-rotation-alignment": "viewport",
//             "text-max-angle": 38,
//             "symbol-spacing": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 11,
//                 400,
//                 14,
//                 600
//             ],
//             "text-font": ["DIN Pro Bold", "Arial Unicode MS Bold"],
//             "symbol-placement": ["step", ["zoom"], "point", 11, "line"],
//             "text-rotation-alignment": "viewport",
//             "text-field": ["get", "ref"],
//             "text-letter-spacing": 0.05
//         },
//         "paint": {
//             "text-color": [
//                 "case",
//                 ["has", "shield_beta"],
//                 [
//                     "case",
//                     [
//                         "all",
//                         ["has", "shield_text_color_beta"],
//                         [
//                             "to-boolean",
//                             [
//                                 "coalesce",
//                                 [
//                                     "image",
//                                     [
//                                         "concat",
//                                         ["get", "shield_beta"],
//                                         "-",
//                                         ["to-string", ["get", "reflen"]]
//                                     ]
//                                 ],
//                                 ""
//                             ]
//                         ]
//                     ],
//                     [
//                         "match",
//                         ["get", "shield_text_color_beta"],
//                         "white",
//                         "hsl(0, 0%, 100%)",
//                         "yellow",
//                         "hsl(50, 63%, 70%)",
//                         "orange",
//                         "hsl(25, 63%, 75%)",
//                         "blue",
//                         "hsl(230, 36%, 44%)",
//                         "red",
//                         "hsl(0, 54%, 59%)",
//                         "green",
//                         "hsl(140, 46%, 37%)",
//                         "hsl(230, 11%, 13%)"
//                     ],
//                     "hsl(230, 11%, 13%)"
//                 ],
//                 [
//                     "match",
//                     ["get", "shield_text_color"],
//                     "white",
//                     "hsl(0, 0%, 100%)",
//                     "yellow",
//                     "hsl(50, 63%, 70%)",
//                     "orange",
//                     "hsl(25, 63%, 75%)",
//                     "blue",
//                     "hsl(230, 36%, 44%)",
//                     "red",
//                     "hsl(0, 54%, 59%)",
//                     "green",
//                     "hsl(140, 46%, 37%)",
//                     "hsl(230, 11%, 13%)"
//                 ]
//             ]
//         }
//     },
//     {
//         "id": "road-exit-shield",
//         "type": "symbol",
//         "metadata": {
//             "mapbox:featureComponent": "road-network",
//             "mapbox:group": "Road network, road-labels"
//         },
//         "source": "composite",
//         "source-layer": "motorway_junction",
//         "minzoom": 14,
//         "filter": [
//             "all",
//             ["has", "reflen"],
//             ["<=", ["get", "reflen"], 9],
//             [
//                 "step",
//                 ["pitch"],
//                 true,
//                 50,
//                 ["<", ["distance-from-center"], 1],
//                 60,
//                 ["<", ["distance-from-center"], 1.5],
//                 70,
//                 ["<", ["distance-from-center"], 2]
//             ]
//         ],
//         "layout": {
//             "text-field": ["get", "ref"],
//             "text-size": 9,
//             "icon-image": [
//                 "concat",
//                 "motorway-exit-",
//                 ["to-string", ["get", "reflen"]]
//             ],
//             "text-font": ["DIN Pro Bold", "Arial Unicode MS Bold"]
//         },
//         "paint": {
//             "text-color": "hsl(0, 0%, 100%)",
//             "text-translate": [0, 0]
//         }
//     },
//     {
//         "id": "path-pedestrian-label",
//         "type": "symbol",
//         "metadata": {
//             "mapbox:featureComponent": "walking-cycling",
//             "mapbox:group": "Walking, cycling, etc., walking-cycling-labels"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 12,
//         "filter": [
//             "all",
//             ["case", ["has", "layer"], [">=", ["get", "layer"], 0], true],
//             [
//                 "step",
//                 ["zoom"],
//                 ["match", ["get", "class"], ["pedestrian"], true, false],
//                 15,
//                 [
//                     "match",
//                     ["get", "class"],
//                     ["path", "pedestrian"],
//                     true,
//                     false
//                 ]
//             ],
//             [
//                 "step",
//                 ["pitch"],
//                 true,
//                 50,
//                 ["<", ["distance-from-center"], 1],
//                 60,
//                 ["<", ["distance-from-center"], 1.5],
//                 70,
//                 ["<", ["distance-from-center"], 2]
//             ]
//         ],
//         "layout": {
//             "text-size": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 10,
//                 ["match", ["get", "class"], "pedestrian", 9.9, 7.15],
//                 18,
//                 [
//                     "match",
//                     ["get", "class"],
//                     "pedestrian",
//                     15.400000000000002,
//                     14.3
//                 ]
//             ],
//             "text-max-angle": 30,
//             "text-font": ["DIN Pro Medium", "Arial Unicode MS Regular"],
//             "symbol-placement": "line",
//             "text-padding": 1,
//             "text-rotation-alignment": "map",
//             "text-pitch-alignment": "viewport",
//             "text-field": ["coalesce", ["get", "name_en"], ["get", "name"]],
//             "text-letter-spacing": 0.01
//         },
//         "paint": {
//             "text-color": "hsl(0, 0%, 100%)",
//             "text-halo-color": "hsl(0, 5%, 0%)",
//             "text-halo-width": 1,
//             "text-halo-blur": 1
//         }
//     },
//     {
//         "id": "ferry-aerialway-label",
//         "type": "symbol",
//         "metadata": {
//             "mapbox:featureComponent": "transit",
//             "mapbox:group": "Transit, ferry-aerialway-labels"
//         },
//         "source": "composite",
//         "source-layer": "road",
//         "minzoom": 15,
//         "filter": [
//             "all",
//             ["match", ["get", "class"], "aerialway", true, false],
//             [
//                 "step",
//                 ["pitch"],
//                 true,
//                 50,
//                 ["<", ["distance-from-center"], 1],
//                 60,
//                 ["<", ["distance-from-center"], 1.5],
//                 70,
//                 ["<", ["distance-from-center"], 2]
//             ]
//         ],
//         "layout": {
//             "text-size": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 10,
//                 7.15,
//                 18,
//                 14.3
//             ],
//             "text-max-angle": 30,
//             "text-font": ["DIN Pro Medium", "Arial Unicode MS Regular"],
//             "symbol-placement": "line",
//             "text-padding": 1,
//             "text-rotation-alignment": "map",
//             "text-pitch-alignment": "viewport",
//             "text-field": ["coalesce", ["get", "name_en"], ["get", "name"]],
//             "text-letter-spacing": 0.01
//         },
//         "paint": {
//             "text-color": [
//                 "match",
//                 ["get", "class"],
//                 "ferry",
//                 "hsl(240, 68%, 94%)",
//                 "hsl(204, 100%, 80%)"
//             ],
//             "text-halo-color": [
//                 "match",
//                 ["get", "class"],
//                 "ferry",
//                 "hsl(240, 100%, 62%)",
//                 "hsl(0, 0%, 10%)"
//             ],
//             "text-halo-width": 1,
//             "text-halo-blur": 1
//         }
//     },
//     {
//         "id": "waterway-label",
//         "type": "symbol",
//         "metadata": {
//             "mapbox:featureComponent": "natural-features",
//             "mapbox:group": "Natural features, natural-labels"
//         },
//         "source": "composite",
//         "source-layer": "natural_label",
//         "minzoom": 13,
//         "filter": [
//             "all",
//             [
//                 "match",
//                 ["get", "class"],
//                 [
//                     "canal",
//                     "river",
//                     "stream",
//                     "disputed_canal",
//                     "disputed_river",
//                     "disputed_stream"
//                 ],
//                 ["match", ["get", "worldview"], ["all", "US"], true, false],
//                 false
//             ],
//             [
//                 "step",
//                 ["pitch"],
//                 true,
//                 50,
//                 ["<", ["distance-from-center"], 1],
//                 60,
//                 ["<", ["distance-from-center"], 1.5],
//                 70,
//                 ["<", ["distance-from-center"], 2]
//             ],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {
//             "text-font": ["DIN Pro Italic", "Arial Unicode MS Regular"],
//             "text-max-angle": 30,
//             "symbol-spacing": [
//                 "interpolate",
//                 ["linear", 1],
//                 ["zoom"],
//                 15,
//                 250,
//                 17,
//                 400
//             ],
//             "text-size": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 13,
//                 12,
//                 18,
//                 18
//             ],
//             "symbol-placement": "line",
//             "text-pitch-alignment": "viewport",
//             "text-field": ["coalesce", ["get", "name_en"], ["get", "name"]]
//         },
//         "paint": {
//             "text-color": "hsl(240, 68%, 90%)",
//             "text-halo-color": "hsla(0, 0%, 0%, 0.5)",
//             "text-halo-width": 1,
//             "text-halo-blur": 1
//         }
//     },
//     {
//         "id": "natural-line-label",
//         "type": "symbol",
//         "metadata": {
//             "mapbox:featureComponent": "natural-features",
//             "mapbox:group": "Natural features, natural-labels"
//         },
//         "source": "composite",
//         "source-layer": "natural_label",
//         "minzoom": 4,
//         "filter": [
//             "all",
//             [
//                 "match",
//                 ["get", "class"],
//                 [
//                     "glacier",
//                     "landform",
//                     "disputed_glacier",
//                     "disputed_landform"
//                 ],
//                 ["match", ["get", "worldview"], ["all", "US"], true, false],
//                 false
//             ],
//             ["<=", ["get", "filterrank"], 2],
//             [
//                 "step",
//                 ["pitch"],
//                 true,
//                 50,
//                 ["<", ["distance-from-center"], 1],
//                 60,
//                 ["<", ["distance-from-center"], 1.5],
//                 70,
//                 ["<", ["distance-from-center"], 2]
//             ],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {
//             "text-size": [
//                 "step",
//                 ["zoom"],
//                 ["step", ["get", "sizerank"], 18, 5, 12],
//                 17,
//                 ["step", ["get", "sizerank"], 18, 13, 12]
//             ],
//             "text-max-angle": 30,
//             "text-field": ["coalesce", ["get", "name_en"], ["get", "name"]],
//             "text-font": ["DIN Pro Bold", "Arial Unicode MS Bold"],
//             "symbol-placement": "line-center",
//             "text-pitch-alignment": "viewport"
//         },
//         "paint": {
//             "text-halo-width": 0.5,
//             "text-halo-color": "hsl(0, 0%, 0%)",
//             "text-halo-blur": 0.5,
//             "text-color": "hsl(0, 0%, 100%)"
//         }
//     },
//     {
//         "id": "natural-point-label",
//         "type": "symbol",
//         "metadata": {
//             "mapbox:featureComponent": "natural-features",
//             "mapbox:group": "Natural features, natural-labels"
//         },
//         "source": "composite",
//         "source-layer": "natural_label",
//         "minzoom": 4,
//         "filter": [
//             "all",
//             [
//                 "match",
//                 ["get", "class"],
//                 [
//                     "dock",
//                     "glacier",
//                     "landform",
//                     "water_feature",
//                     "wetland",
//                     "disputed_dock",
//                     "disputed_glacier",
//                     "disputed_landform",
//                     "disputed_water_feature",
//                     "disputed_wetland"
//                 ],
//                 ["match", ["get", "worldview"], ["all", "US"], true, false],
//                 false
//             ],
//             ["<=", ["get", "filterrank"], 2],
//             [
//                 "step",
//                 ["pitch"],
//                 true,
//                 50,
//                 ["<", ["distance-from-center"], 1],
//                 60,
//                 ["<", ["distance-from-center"], 1.5],
//                 70,
//                 ["<", ["distance-from-center"], 2]
//             ],
//             ["==", ["geometry-type"], "Point"]
//         ],
//         "layout": {
//             "text-size": [
//                 "step",
//                 ["zoom"],
//                 ["step", ["get", "sizerank"], 18, 5, 12],
//                 17,
//                 ["step", ["get", "sizerank"], 18, 13, 12]
//             ],
//             "icon-image": [
//                 "case",
//                 ["has", "maki_beta"],
//                 [
//                     "coalesce",
//                     ["image", ["get", "maki_beta"]],
//                     ["image", ["get", "maki"]]
//                 ],
//                 ["image", ["get", "maki"]]
//             ],
//             "text-font": ["DIN Pro Bold", "Arial Unicode MS Bold"],
//             "text-offset": [
//                 "step",
//                 ["zoom"],
//                 [
//                     "step",
//                     ["get", "sizerank"],
//                     ["literal", [0, 0]],
//                     5,
//                     ["literal", [0, 0.55]]
//                 ],
//                 17,
//                 [
//                     "step",
//                     ["get", "sizerank"],
//                     ["literal", [0, 0]],
//                     13,
//                     ["literal", [0, 0.6000000000000001]]
//                 ]
//             ],
//             "text-anchor": [
//                 "step",
//                 ["zoom"],
//                 ["step", ["get", "sizerank"], "center", 5, "top"],
//                 17,
//                 ["step", ["get", "sizerank"], "center", 13, "top"]
//             ],
//             "text-field": ["coalesce", ["get", "name_en"], ["get", "name"]]
//         },
//         "paint": {
//             "icon-opacity": [
//                 "step",
//                 ["zoom"],
//                 ["step", ["get", "sizerank"], 0, 5, 1],
//                 17,
//                 ["step", ["get", "sizerank"], 0, 13, 1]
//             ],
//             "text-halo-color": "hsl(0, 0%, 10%)",
//             "text-halo-width": 0.5,
//             "text-halo-blur": 0.5,
//             "text-color": "hsl(0, 0%, 100%)"
//         }
//     },
//     {
//         "id": "water-line-label",
//         "type": "symbol",
//         "metadata": {
//             "mapbox:featureComponent": "natural-features",
//             "mapbox:group": "Natural features, natural-labels"
//         },
//         "source": "composite",
//         "source-layer": "natural_label",
//         "minzoom": 1,
//         "filter": [
//             "all",
//             [
//                 "match",
//                 ["get", "class"],
//                 [
//                     "bay",
//                     "ocean",
//                     "reservoir",
//                     "sea",
//                     "water",
//                     "disputed_bay",
//                     "disputed_ocean",
//                     "disputed_reservoir",
//                     "disputed_sea",
//                     "disputed_water"
//                 ],
//                 ["match", ["get", "worldview"], ["all", "US"], true, false],
//                 false
//             ],
//             [
//                 "step",
//                 ["pitch"],
//                 true,
//                 50,
//                 ["<", ["distance-from-center"], 1],
//                 60,
//                 ["<", ["distance-from-center"], 1.5],
//                 70,
//                 ["<", ["distance-from-center"], 2]
//             ],
//             ["==", ["geometry-type"], "LineString"]
//         ],
//         "layout": {
//             "text-size": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 0,
//                 ["*", ["-", 16, ["sqrt", ["get", "sizerank"]]], 1],
//                 22,
//                 ["*", ["-", 22, ["sqrt", ["get", "sizerank"]]], 1]
//             ],
//             "text-max-angle": 30,
//             "text-letter-spacing": [
//                 "match",
//                 ["get", "class"],
//                 "ocean",
//                 0.25,
//                 ["sea", "bay"],
//                 0.15,
//                 0
//             ],
//             "text-font": ["DIN Pro Italic", "Arial Unicode MS Regular"],
//             "symbol-placement": "line-center",
//             "text-pitch-alignment": "viewport",
//             "text-field": ["coalesce", ["get", "name_en"], ["get", "name"]]
//         },
//         "paint": {
//             "text-color": [
//                 "match",
//                 ["get", "class"],
//                 ["bay", "ocean", "sea"],
//                 "hsl(240, 96%, 82%)",
//                 "hsl(240, 68%, 90%)"
//             ],
//             "text-halo-color": "hsla(0, 0%, 0%, 0.5)",
//             "text-halo-width": 1,
//             "text-halo-blur": 1
//         }
//     },
//     {
//         "id": "water-point-label",
//         "type": "symbol",
//         "metadata": {
//             "mapbox:featureComponent": "natural-features",
//             "mapbox:group": "Natural features, natural-labels"
//         },
//         "source": "composite",
//         "source-layer": "natural_label",
//         "minzoom": 1,
//         "filter": [
//             "all",
//             [
//                 "match",
//                 ["get", "class"],
//                 [
//                     "bay",
//                     "ocean",
//                     "reservoir",
//                     "sea",
//                     "water",
//                     "disputed_bay",
//                     "disputed_ocean",
//                     "disputed_reservoir",
//                     "disputed_sea",
//                     "disputed_water"
//                 ],
//                 ["match", ["get", "worldview"], ["all", "US"], true, false],
//                 false
//             ],
//             [
//                 "step",
//                 ["pitch"],
//                 true,
//                 50,
//                 ["<", ["distance-from-center"], 1],
//                 60,
//                 ["<", ["distance-from-center"], 1.5],
//                 70,
//                 ["<", ["distance-from-center"], 2]
//             ],
//             ["==", ["geometry-type"], "Point"]
//         ],
//         "layout": {
//             "text-line-height": 1.3,
//             "text-size": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 0,
//                 ["*", ["-", 16, ["sqrt", ["get", "sizerank"]]], 1],
//                 22,
//                 ["*", ["-", 22, ["sqrt", ["get", "sizerank"]]], 1]
//             ],
//             "text-font": ["DIN Pro Italic", "Arial Unicode MS Regular"],
//             "text-field": ["coalesce", ["get", "name_en"], ["get", "name"]],
//             "text-letter-spacing": [
//                 "match",
//                 ["get", "class"],
//                 "ocean",
//                 0.25,
//                 ["bay", "sea"],
//                 0.15,
//                 0.01
//             ],
//             "text-max-width": [
//                 "match",
//                 ["get", "class"],
//                 "ocean",
//                 4,
//                 "sea",
//                 5,
//                 ["bay", "water"],
//                 7,
//                 10
//             ]
//         },
//         "paint": {
//             "text-color": [
//                 "match",
//                 ["get", "class"],
//                 ["bay", "ocean", "sea"],
//                 "hsl(240, 96%, 82%)",
//                 "hsl(240, 68%, 90%)"
//             ],
//             "text-halo-color": "hsla(0, 0%, 0%, 0.5)",
//             "text-halo-width": 1,
//             "text-halo-blur": 1
//         }
//     },
//     {
//         "id": "poi-label",
//         "type": "symbol",
//         "metadata": {
//             "mapbox:featureComponent": "point-of-interest-labels",
//             "mapbox:group": "Point of interest labels, poi-labels"
//         },
//         "source": "composite",
//         "source-layer": "poi_label",
//         "minzoom": 6,
//         "filter": [
//             "all",
//             [
//                 "<=",
//                 ["get", "filterrank"],
//                 ["+", ["step", ["zoom"], 0, 16, 1, 17, 2], 3]
//             ],
//             [
//                 "step",
//                 ["pitch"],
//                 true,
//                 50,
//                 ["<", ["distance-from-center"], 2],
//                 60,
//                 ["<", ["distance-from-center"], 2.5],
//                 70,
//                 ["<", ["distance-from-center"], 3]
//             ]
//         ],
//         "layout": {
//             "text-size": [
//                 "step",
//                 ["zoom"],
//                 ["step", ["get", "sizerank"], 18, 5, 12],
//                 17,
//                 ["step", ["get", "sizerank"], 18, 13, 12]
//             ],
//             "icon-image": [
//                 "case",
//                 ["has", "maki_beta"],
//                 [
//                     "coalesce",
//                     ["image", ["get", "maki_beta"]],
//                     ["image", ["get", "maki"]]
//                 ],
//                 ["image", ["get", "maki"]]
//             ],
//             "text-font": ["DIN Pro Bold", "Arial Unicode MS Bold"],
//             "text-offset": [
//                 "step",
//                 ["zoom"],
//                 [
//                     "step",
//                     ["get", "sizerank"],
//                     ["literal", [0, 0]],
//                     5,
//                     ["literal", [0, 0.8]]
//                 ],
//                 17,
//                 [
//                     "step",
//                     ["get", "sizerank"],
//                     ["literal", [0, 0]],
//                     13,
//                     ["literal", [0, 0.8]]
//                 ]
//             ],
//             "text-anchor": [
//                 "step",
//                 ["zoom"],
//                 ["step", ["get", "sizerank"], "center", 5, "top"],
//                 17,
//                 ["step", ["get", "sizerank"], "center", 13, "top"]
//             ],
//             "text-field": ["coalesce", ["get", "name_en"], ["get", "name"]]
//         },
//         "paint": {
//             "icon-opacity": [
//                 "step",
//                 ["zoom"],
//                 ["step", ["get", "sizerank"], 0, 5, 1],
//                 17,
//                 ["step", ["get", "sizerank"], 0, 13, 1]
//             ],
//             "text-halo-color": "hsl(0, 0%, 10%)",
//             "text-halo-width": 0.5,
//             "text-halo-blur": 0.5,
//             "text-color": [
//                 "match",
//                 ["get", "class"],
//                 "park_like",
//                 "hsl(110, 100%, 85%)",
//                 "education",
//                 "hsl(30, 100%, 85%)",
//                 "medical",
//                 "hsl(0, 100%, 85%)",
//                 "hsl(0, 0%, 100%)"
//             ]
//         }
//     },
//     {
//         "id": "transit-label",
//         "type": "symbol",
//         "metadata": {
//             "mapbox:featureComponent": "transit",
//             "mapbox:group": "Transit, transit-labels"
//         },
//         "source": "composite",
//         "source-layer": "transit_stop_label",
//         "minzoom": 12,
//         "filter": [
//             "all",
//             [
//                 "step",
//                 ["zoom"],
//                 [
//                     "all",
//                     ["<=", ["get", "filterrank"], 4],
//                     [
//                         "match",
//                         ["get", "mode"],
//                         "rail",
//                         true,
//                         "metro_rail",
//                         true,
//                         false
//                     ],
//                     ["!=", ["get", "stop_type"], "entrance"]
//                 ],
//                 14,
//                 [
//                     "all",
//                     [
//                         "match",
//                         ["get", "mode"],
//                         "rail",
//                         true,
//                         "metro_rail",
//                         true,
//                         false
//                     ],
//                     ["!=", ["get", "stop_type"], "entrance"]
//                 ],
//                 15,
//                 [
//                     "all",
//                     [
//                         "match",
//                         ["get", "mode"],
//                         "rail",
//                         true,
//                         "metro_rail",
//                         true,
//                         "light_rail",
//                         true,
//                         false
//                     ],
//                     ["!=", ["get", "stop_type"], "entrance"]
//                 ],
//                 16,
//                 [
//                     "all",
//                     [
//                         "match",
//                         ["get", "mode"],
//                         "ferry",
//                         false,
//                         "bus",
//                         false,
//                         true
//                     ],
//                     ["!=", ["get", "stop_type"], "entrance"]
//                 ],
//                 17,
//                 [
//                     "all",
//                     ["match", ["get", "mode"], "ferry", false, true],
//                     ["!=", ["get", "stop_type"], "entrance"]
//                 ],
//                 19,
//                 ["match", ["get", "mode"], "ferry", false, true]
//             ],
//             [
//                 "step",
//                 ["pitch"],
//                 true,
//                 50,
//                 ["<", ["distance-from-center"], 1],
//                 60,
//                 ["<", ["distance-from-center"], 1.5],
//                 70,
//                 ["<", ["distance-from-center"], 2]
//             ]
//         ],
//         "layout": {
//             "text-size": 12,
//             "icon-image": ["get", "network"],
//             "text-font": ["DIN Pro Bold", "Arial Unicode MS Bold"],
//             "text-justify": [
//                 "match",
//                 ["get", "stop_type"],
//                 "entrance",
//                 "left",
//                 "center"
//             ],
//             "text-offset": [
//                 "match",
//                 ["get", "stop_type"],
//                 "entrance",
//                 ["literal", [1, 0]],
//                 ["literal", [0, 0.8]]
//             ],
//             "text-anchor": [
//                 "match",
//                 ["get", "stop_type"],
//                 "entrance",
//                 "left",
//                 "top"
//             ],
//             "text-field": [
//                 "step",
//                 ["zoom"],
//                 "",
//                 13,
//                 [
//                     "match",
//                     ["get", "mode"],
//                     ["rail", "metro_rail"],
//                     ["coalesce", ["get", "name_en"], ["get", "name"]],
//                     ""
//                 ],
//                 14,
//                 [
//                     "match",
//                     ["get", "mode"],
//                     ["bus", "bicycle"],
//                     "",
//                     ["coalesce", ["get", "name_en"], ["get", "name"]]
//                 ],
//                 18,
//                 ["coalesce", ["get", "name_en"], ["get", "name"]]
//             ],
//             "text-letter-spacing": 0.01,
//             "text-max-width": [
//                 "match",
//                 ["get", "stop_type"],
//                 "entrance",
//                 15,
//                 9
//             ]
//         },
//         "paint": {
//             "text-halo-color": "hsl(0, 0%, 10%)",
//             "text-color": "hsl(204, 100%, 80%)",
//             "text-halo-blur": 0.5,
//             "text-halo-width": 0.5
//         }
//     },
//     {
//         "id": "airport-label",
//         "type": "symbol",
//         "metadata": {
//             "mapbox:featureComponent": "transit",
//             "mapbox:group": "Transit, transit-labels"
//         },
//         "source": "composite",
//         "source-layer": "airport_label",
//         "minzoom": 8,
//         "filter": [
//             "all",
//             [
//                 "match",
//                 ["get", "class"],
//                 [
//                     "military",
//                     "civil",
//                     "disputed_military",
//                     "disputed_civil"
//                 ],
//                 ["match", ["get", "worldview"], ["all", "US"], true, false],
//                 false
//             ],
//             [
//                 "step",
//                 ["pitch"],
//                 true,
//                 50,
//                 ["<", ["distance-from-center"], 3],
//                 60,
//                 ["<", ["distance-from-center"], 4],
//                 70,
//                 ["<", ["distance-from-center"], 5]
//             ]
//         ],
//         "layout": {
//             "text-line-height": 1.1,
//             "text-size": ["step", ["get", "sizerank"], 18, 9, 12],
//             "icon-image": ["get", "maki"],
//             "text-font": ["DIN Pro Bold", "Arial Unicode MS Bold"],
//             "text-offset": [0, 0.8],
//             "text-rotation-alignment": "viewport",
//             "text-anchor": "top",
//             "text-field": [
//                 "step",
//                 ["get", "sizerank"],
//                 [
//                     "case",
//                     ["has", "ref"],
//                     [
//                         "concat",
//                         ["get", "ref"],
//                         " -\n",
//                         ["coalesce", ["get", "name_en"], ["get", "name"]]
//                     ],
//                     ["coalesce", ["get", "name_en"], ["get", "name"]]
//                 ],
//                 15,
//                 ["get", "ref"]
//             ],
//             "text-letter-spacing": 0.01,
//             "text-max-width": 9
//         },
//         "paint": {
//             "text-color": "hsl(0, 0%, 100%)",
//             "text-halo-color": "hsl(0, 0%, 10%)",
//             "text-halo-width": 1
//         }
//     },
//     {
//         "id": "settlement-subdivision-label",
//         "type": "symbol",
//         "metadata": {
//             "mapbox:featureComponent": "place-labels",
//             "mapbox:group": "Place labels, place-labels"
//         },
//         "source": "composite",
//         "source-layer": "place_label",
//         "minzoom": 10,
//         "maxzoom": 15,
//         "filter": [
//             "all",
//             [
//                 "match",
//                 ["get", "class"],
//                 [
//                     "settlement_subdivision",
//                     "disputed_settlement_subdivision"
//                 ],
//                 ["match", ["get", "worldview"], ["all", "US"], true, false],
//                 false
//             ],
//             ["<=", ["get", "filterrank"], 4],
//             [
//                 "step",
//                 ["pitch"],
//                 true,
//                 50,
//                 ["<", ["distance-from-center"], 3],
//                 60,
//                 ["<", ["distance-from-center"], 4],
//                 70,
//                 ["<", ["distance-from-center"], 5]
//             ]
//         ],
//         "layout": {
//             "text-field": [
//                 "coalesce",
//                 ["get", "name_local"],
//                 ["get", "name"]
//             ],
//             "text-transform": "uppercase",
//             "text-font": ["DIN Pro Medium", "Arial Unicode MS Regular"],
//             "text-letter-spacing": [
//                 "match",
//                 ["get", "type"],
//                 "suburb",
//                 0.15,
//                 0.05
//             ],
//             "text-max-width": 7,
//             "text-padding": 3,
//             "text-size": [
//                 "interpolate",
//                 ["cubic-bezier", 0.5, 0, 1, 1],
//                 ["zoom"],
//                 11,
//                 [
//                     "match",
//                     ["get", "type"],
//                     "suburb",
//                     12.100000000000001,
//                     11.55
//                 ],
//                 15,
//                 [
//                     "match",
//                     ["get", "type"],
//                     "suburb",
//                     16.5,
//                     15.400000000000002
//                 ]
//             ]
//         },
//         "paint": {
//             "text-halo-color": "hsla(0, 5%, 0%, 0.75)",
//             "text-halo-width": 1,
//             "text-color": "hsl(0, 0%, 100%)",
//             "text-halo-blur": 0.5
//         }
//     },
//     {
//         "id": "settlement-minor-label",
//         "type": "symbol",
//         "metadata": {
//             "mapbox:featureComponent": "place-labels",
//             "mapbox:group": "Place labels, place-labels"
//         },
//         "source": "composite",
//         "source-layer": "place_label",
//         "minzoom": 2,
//         "maxzoom": 13,
//         "filter": [
//             "all",
//             ["<=", ["get", "filterrank"], 3],
//             [
//                 "match",
//                 ["get", "class"],
//                 ["settlement", "disputed_settlement"],
//                 ["match", ["get", "worldview"], ["all", "US"], true, false],
//                 false
//             ],
//             [
//                 "step",
//                 ["zoom"],
//                 [">", ["get", "symbolrank"], 6],
//                 4,
//                 [">=", ["get", "symbolrank"], 7],
//                 6,
//                 [">=", ["get", "symbolrank"], 8],
//                 7,
//                 [">=", ["get", "symbolrank"], 10],
//                 10,
//                 [">=", ["get", "symbolrank"], 11],
//                 11,
//                 [">=", ["get", "symbolrank"], 13],
//                 12,
//                 [">=", ["get", "symbolrank"], 15]
//             ],
//             [
//                 "step",
//                 ["pitch"],
//                 true,
//                 50,
//                 ["<", ["distance-from-center"], 3],
//                 60,
//                 ["<", ["distance-from-center"], 4],
//                 70,
//                 ["<", ["distance-from-center"], 5]
//             ]
//         ],
//         "layout": {
//             "text-line-height": 1.1,
//             "text-size": [
//                 "interpolate",
//                 ["cubic-bezier", 0.2, 0, 0.9, 1],
//                 ["zoom"],
//                 3,
//                 ["step", ["get", "symbolrank"], 12.100000000000001, 9, 11],
//                 6,
//                 [
//                     "step",
//                     ["get", "symbolrank"],
//                     15.400000000000002,
//                     9,
//                     13.200000000000001,
//                     12,
//                     11
//                 ],
//                 8,
//                 [
//                     "step",
//                     ["get", "symbolrank"],
//                     17.6,
//                     9,
//                     15.400000000000002,
//                     12,
//                     13.200000000000001,
//                     15,
//                     11
//                 ],
//                 13,
//                 [
//                     "step",
//                     ["get", "symbolrank"],
//                     24.200000000000003,
//                     9,
//                     22,
//                     12,
//                     17.6,
//                     15,
//                     15.400000000000002
//                 ]
//             ],
//             "text-radial-offset": [
//                 "step",
//                 ["zoom"],
//                 ["match", ["get", "capital"], 2, 0.6, 0.55],
//                 8,
//                 0
//             ],
//             "symbol-sort-key": ["get", "symbolrank"],
//             "icon-image": [
//                 "step",
//                 ["zoom"],
//                 [
//                     "case",
//                     ["==", ["get", "capital"], 2],
//                     "border-dot-13",
//                     [
//                         "step",
//                         ["get", "symbolrank"],
//                         "dot-11",
//                         9,
//                         "dot-10",
//                         11,
//                         "dot-9"
//                     ]
//                 ],
//                 8,
//                 ""
//             ],
//             "text-font": ["DIN Pro Medium", "Arial Unicode MS Regular"],
//             "text-justify": "auto",
//             "text-anchor": [
//                 "step",
//                 ["zoom"],
//                 ["get", "text_anchor"],
//                 8,
//                 "center"
//             ],
//             "text-field": [
//                 "coalesce",
//                 ["get", "name_local"],
//                 ["get", "name"]
//             ],
//             "text-max-width": 7
//         },
//         "paint": {
//             "text-color": "hsl(0, 0%, 95%)",
//             "text-halo-color": "hsl(0, 5%, 0%)",
//             "text-halo-width": 1,
//             "text-halo-blur": 1
//         }
//     },
//     {
//         "id": "settlement-major-label",
//         "type": "symbol",
//         "metadata": {
//             "mapbox:featureComponent": "place-labels",
//             "mapbox:group": "Place labels, place-labels"
//         },
//         "source": "composite",
//         "source-layer": "place_label",
//         "minzoom": 2,
//         "maxzoom": 15,
//         "filter": [
//             "all",
//             ["<=", ["get", "filterrank"], 3],
//             [
//                 "match",
//                 ["get", "class"],
//                 ["settlement", "disputed_settlement"],
//                 ["match", ["get", "worldview"], ["all", "US"], true, false],
//                 false
//             ],
//             [
//                 "step",
//                 ["zoom"],
//                 false,
//                 2,
//                 ["<=", ["get", "symbolrank"], 6],
//                 4,
//                 ["<", ["get", "symbolrank"], 7],
//                 6,
//                 ["<", ["get", "symbolrank"], 8],
//                 7,
//                 ["<", ["get", "symbolrank"], 10],
//                 10,
//                 ["<", ["get", "symbolrank"], 11],
//                 11,
//                 ["<", ["get", "symbolrank"], 13],
//                 12,
//                 ["<", ["get", "symbolrank"], 15],
//                 13,
//                 [">=", ["get", "symbolrank"], 11],
//                 14,
//                 [">=", ["get", "symbolrank"], 15]
//             ],
//             [
//                 "step",
//                 ["pitch"],
//                 true,
//                 50,
//                 ["<", ["distance-from-center"], 3],
//                 60,
//                 ["<", ["distance-from-center"], 4],
//                 70,
//                 ["<", ["distance-from-center"], 5]
//             ]
//         ],
//         "layout": {
//             "text-line-height": 1.1,
//             "text-size": [
//                 "interpolate",
//                 ["cubic-bezier", 0.2, 0, 0.9, 1],
//                 ["zoom"],
//                 3,
//                 [
//                     "step",
//                     ["get", "symbolrank"],
//                     14.3,
//                     6,
//                     12.100000000000001
//                 ],
//                 6,
//                 [
//                     "step",
//                     ["get", "symbolrank"],
//                     19.8,
//                     6,
//                     17.6,
//                     7,
//                     15.400000000000002
//                 ],
//                 8,
//                 [
//                     "step",
//                     ["get", "symbolrank"],
//                     22,
//                     9,
//                     17.6,
//                     10,
//                     15.400000000000002
//                 ],
//                 15,
//                 [
//                     "step",
//                     ["get", "symbolrank"],
//                     26.400000000000002,
//                     9,
//                     22,
//                     12,
//                     17.6,
//                     15,
//                     15.400000000000002
//                 ]
//             ],
//             "text-radial-offset": [
//                 "step",
//                 ["zoom"],
//                 ["match", ["get", "capital"], 2, 0.6, 0.55],
//                 8,
//                 0
//             ],
//             "symbol-sort-key": ["get", "symbolrank"],
//             "icon-image": [
//                 "step",
//                 ["zoom"],
//                 [
//                     "case",
//                     ["==", ["get", "capital"], 2],
//                     "border-dot-13",
//                     [
//                         "step",
//                         ["get", "symbolrank"],
//                         "dot-11",
//                         9,
//                         "dot-10",
//                         11,
//                         "dot-9"
//                     ]
//                 ],
//                 8,
//                 ""
//             ],
//             "text-font": ["DIN Pro Medium", "Arial Unicode MS Regular"],
//             "text-justify": [
//                 "step",
//                 ["zoom"],
//                 [
//                     "match",
//                     ["get", "text_anchor"],
//                     ["left", "bottom-left", "top-left"],
//                     "left",
//                     ["right", "bottom-right", "top-right"],
//                     "right",
//                     "center"
//                 ],
//                 8,
//                 "center"
//             ],
//             "text-anchor": [
//                 "step",
//                 ["zoom"],
//                 ["get", "text_anchor"],
//                 8,
//                 "center"
//             ],
//             "text-field": [
//                 "coalesce",
//                 ["get", "name_local"],
//                 ["get", "name"]
//             ],
//             "text-max-width": 7
//         },
//         "paint": {
//             "text-color": "hsl(0, 0%, 95%)",
//             "text-halo-color": "hsl(0, 5%, 0%)",
//             "text-halo-width": 1,
//             "text-halo-blur": 1
//         }
//     },
//     {
//         "id": "state-label",
//         "type": "symbol",
//         "metadata": {
//             "mapbox:featureComponent": "place-labels",
//             "mapbox:group": "Place labels, place-labels"
//         },
//         "source": "composite",
//         "source-layer": "place_label",
//         "minzoom": 3,
//         "maxzoom": 9,
//         "filter": [
//             "all",
//             [
//                 "match",
//                 ["get", "class"],
//                 ["state", "disputed_state"],
//                 ["match", ["get", "worldview"], ["all", "US"], true, false],
//                 false
//             ],
//             [
//                 "step",
//                 ["pitch"],
//                 true,
//                 50,
//                 ["<", ["distance-from-center"], 3],
//                 60,
//                 ["<", ["distance-from-center"], 4],
//                 70,
//                 ["<", ["distance-from-center"], 5]
//             ]
//         ],
//         "layout": {
//             "text-size": [
//                 "interpolate",
//                 ["cubic-bezier", 0.85, 0.7, 0.65, 1],
//                 ["zoom"],
//                 4,
//                 [
//                     "step",
//                     ["get", "symbolrank"],
//                     9.9,
//                     6,
//                     8.8,
//                     7,
//                     7.700000000000001
//                 ],
//                 9,
//                 [
//                     "step",
//                     ["get", "symbolrank"],
//                     23.1,
//                     6,
//                     17.6,
//                     7,
//                     15.400000000000002
//                 ]
//             ],
//             "text-transform": "uppercase",
//             "text-font": ["DIN Pro Bold", "Arial Unicode MS Bold"],
//             "text-field": [
//                 "coalesce",
//                 ["get", "name_local"],
//                 ["get", "name"]
//             ],
//             "text-letter-spacing": 0.15,
//             "text-max-width": 6
//         },
//         "paint": {
//             "text-color": "hsl(0, 0%, 95%)",
//             "text-halo-color": "hsl(0, 5%, 0%)",
//             "text-halo-width": 1,
//             "text-opacity": 0.5
//         }
//     },
//     {
//         "id": "country-label",
//         "type": "symbol",
//         "metadata": {
//             "mapbox:featureComponent": "place-labels",
//             "mapbox:group": "Place labels, place-labels"
//         },
//         "source": "composite",
//         "source-layer": "place_label",
//         "minzoom": 1,
//         "maxzoom": 10,
//         "filter": [
//             "all",
//             [
//                 "match",
//                 ["get", "class"],
//                 ["country", "disputed_country"],
//                 ["match", ["get", "worldview"], ["all", "US"], true, false],
//                 false
//             ],
//             [
//                 "step",
//                 ["pitch"],
//                 true,
//                 50,
//                 ["<", ["distance-from-center"], 3],
//                 60,
//                 ["<", ["distance-from-center"], 4],
//                 70,
//                 ["<", ["distance-from-center"], 5]
//             ]
//         ],
//         "layout": {
//             "icon-image": "",
//             "text-field": [
//                 "coalesce",
//                 ["get", "name_local"],
//                 ["get", "name"]
//             ],
//             "text-line-height": 1.1,
//             "text-max-width": 6,
//             "text-font": ["DIN Pro Medium", "Arial Unicode MS Regular"],
//             "text-radial-offset": ["step", ["zoom"], 0.6, 8, 0],
//             "text-justify": [
//                 "step",
//                 ["zoom"],
//                 [
//                     "match",
//                     ["get", "text_anchor"],
//                     ["left", "bottom-left", "top-left"],
//                     "left",
//                     ["right", "bottom-right", "top-right"],
//                     "right",
//                     "center"
//                 ],
//                 7,
//                 "auto"
//             ],
//             "text-size": [
//                 "interpolate",
//                 ["cubic-bezier", 0.2, 0, 0.7, 1],
//                 ["zoom"],
//                 1,
//                 [
//                     "step",
//                     ["get", "symbolrank"],
//                     12.100000000000001,
//                     4,
//                     9.9,
//                     5,
//                     8.8
//                 ],
//                 9,
//                 [
//                     "step",
//                     ["get", "symbolrank"],
//                     24.200000000000003,
//                     4,
//                     20.900000000000002,
//                     5,
//                     18.700000000000003
//                 ]
//             ]
//         },
//         "paint": {
//             "icon-opacity": [
//                 "step",
//                 ["zoom"],
//                 ["case", ["has", "text_anchor"], 1, 0],
//                 7,
//                 0
//             ],
//             "text-color": "hsl(0, 0%, 95%)",
//             "text-halo-color": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 2,
//                 "hsla(0, 5%, 0%, 0.75)",
//                 3,
//                 "hsl(0, 5%, 0%)"
//             ],
//             "text-halo-width": 1.25
//         }
//     },
//     {
//         "id": "continent-label",
//         "type": "symbol",
//         "metadata": {
//             "mapbox:featureComponent": "place-labels",
//             "mapbox:group": "Place labels, place-labels"
//         },
//         "source": "composite",
//         "source-layer": "natural_label",
//         "minzoom": 0.75,
//         "maxzoom": 3,
//         "filter": ["==", ["get", "class"], "continent"],
//         "layout": {
//             "text-field": [
//                 "coalesce",
//                 ["get", "name_local"],
//                 ["get", "name"]
//             ],
//             "text-line-height": 1.1,
//             "text-max-width": 6,
//             "text-font": ["DIN Pro Medium", "Arial Unicode MS Regular"],
//             "text-size": [
//                 "interpolate",
//                 ["exponential", 0.5],
//                 ["zoom"],
//                 0,
//                 11,
//                 2.5,
//                 16.5
//             ],
//             "text-transform": "uppercase",
//             "text-letter-spacing": 0.05
//         },
//         "paint": {
//             "text-color": "hsl(0, 0%, 95%)",
//             "text-halo-color": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 0,
//                 "hsla(0, 5%, 0%, 0.75)",
//                 3,
//                 "hsl(0, 5%, 0%)"
//             ],
//             "text-halo-width": 1.5,
//             "text-opacity": [
//                 "interpolate",
//                 ["linear"],
//                 ["zoom"],
//                 0,
//                 0.8,
//                 1.5,
//                 0.5,
//                 2.5,
//                 0
//             ]
//         }
//     }
// ],
